import { filter } from 'lodash';
import { Icon } from '@iconify/react';
import { capitalCase, sentenceCase } from 'change-case';
import { useState, useEffect, useLayoutEffect, useRef, forwardRef } from 'react';
import plusFill from '@iconify/icons-eva/plus-fill';
import { Link as RouterLink, useLocation } from 'react-router-dom';
// material
import { useTheme } from '@material-ui/core/styles';
import {
  Card,
  Table,
  Stack,
  Avatar,
  Button,
  Checkbox,
  TableRow,
  TableBody,
  TableCell,
  Container,
  Typography,
  TableContainer,
  TablePagination,
  Grid,
  Box,
  TableHead,
  CircularProgress,
  Divider,
  Paper,
  TextField,
  IconButton,
  Autocomplete,
  Tabs,
  Tab,
  Tooltip
} from '@material-ui/core';
// redux
import { useDispatch, useSelector } from '../../redux/store';
import { getUserList, deleteUser } from '../../redux/slices/user';
// routes
import { PATH_DASHBOARD } from '../../routes/paths';
// components
import Page from '../../components/Page';
import LoadingScreen from 'src/components/LoadingScreen';
import Label from '../../components/Label';
import Scrollbar from '../../components/Scrollbar';
import SearchNotFound from '../../components/SearchNotFound';
import HeaderBreadcrumbs from '../../components/HeaderBreadcrumbs';
import { UserListHead, UserListToolbar, UserMoreMenu } from '../../components/_dashboard/user/list';
import  ProductToolbar  from 'src/components/_dashboard/user/list/ProductToolbar.js';
import  ProductsSearch  from 'src/components/_dashboard/blog/ProductsSearch.js';
import  ProductsMenu  from 'src/components/_dashboard/user/list/ProductsMenu.js';
import axios from 'axios';
import {COMPANY_LOGO, COMPANY_NAME, REST_API, REST_API_END_POINT, UNITS} from '../../constants/Defaultvalues';
import useCompanyProfile from 'src/hooks/useCompanyProfile';
import moment from 'moment';
import { formatDateOnly } from 'src/utils/dateOnly';
import MaterialInventoryMenu from 'src/components/_dashboard/user/list/MaterialInventoryMenu';
import MaterialInventoryToolbar from 'src/components/_dashboard/user/list/MaterialInventoryToolbar';
import ReceiveOrderMenu from 'src/components/_dashboard/user/list/ReceiveOrderMenu';
import Modal from 'src/components/_dashboard/blog/ProjectModel';
import SendDesignsEmailModal from 'src/components/_dashboard/official-request/SendDesignsEmailModal';
import { useSnackbar } from 'notistack';
import { ArrowBackIos, ArrowForwardIos, Delete, Print, EmailOutlined } from '@material-ui/icons';
import ReactToPrint from 'react-to-print';
import { styled } from '@material-ui/styles';
import QuickbookLogo from '../../../src/assets/quickbookLogo-removebg-preview.png'
import { LoadingButton } from '@material-ui/lab';
import PurchaseOrderInvoicePage from './PurchaseOrderInvoicePage';
import { fUSPrice } from 'src/utils/formatNumber';
import useTableMaxHeight from 'src/hooks/useTableMaxHeight';



// ----------------------------------------------------------------------

const TABLE_HEAD = [
  { id: 'id', label: 'Order\nID', alignRight: false },
  { id: 'qb', label: 'QB', alignRight: false },
  { id: 'name', label: 'Order\nName', alignRight: false },
  { id: 'vendor_name', label: 'Vendor\nName', alignRight: false },
  { id: 'received_date', label: 'Date\nReceived', alignRight: false },
  // { id: 'expected_date', label: 'Date\nExpected', alignRight: false },
  // { id: 'payment_mode', label: 'Payment\nMode', alignRight: false },
  { id: 'payment_status', label: 'Payment\nStatus', alignRight: false },
  // { id: 'addedby', label: 'Added By', alignRight: false },
  // { id: 'timestamp', label: 'Added On', alignRight: false },
  { id: 'status', label: 'Status', alignRight: false },
  { id: 'actions', label: 'Actions', alignRight: false },
  { id: 'options', label: '', alignRight: false},      
  { id: 'arrowback', label: '', alignRight: false},      
];

// ----------------------------------------------------------------------

// function descendingComparator(a, b, orderBy) {
//   if (b[orderBy] < a[orderBy]) {
//     return -1;
//   }
//   if (b[orderBy] > a[orderBy]) {
//     return 1;
//   }
//   return 0;
// }

function descendingComparator(a, b, orderBy) {
  if (orderBy === 'id') {
    const aValue = a[orderBy] || 0;
    const bValue = b[orderBy] || 0;
    return bValue - aValue;
  }
  const aValue = a[orderBy] ? a[orderBy].toString() : '';
  const bValue = b[orderBy] ? b[orderBy].toString() : '';
  return bValue.localeCompare(aValue, undefined, { sensitivity: 'base' });
}

function getComparator(order, orderBy) {
  return order === 'desc'
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}

function applySortFilter(array, comparator, query) {
  const stabilizedThis = array.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) return order;
    return a[1] - b[1];
  });
  if (query) {
    return filter(array, (_user) => _user.name.toLowerCase().indexOf(query.toLowerCase()) !== -1);
  }
  return stabilizedThis.map((el) => el[0]);
}

function scrollReceiveOrderListPaginationToTop(anchorEl, tableScrollBoxEl, tableContainerEl) {
  if (typeof window === 'undefined') return
  const { documentElement, body } = document
  window.scrollTo({ top: 0, left: 0, behavior: 'auto' })
  documentElement.scrollTop = 0
  body.scrollTop = 0

  let el = anchorEl
  while (el) {
    const { overflowY } = window.getComputedStyle(el)
    if (
      (overflowY === 'auto' || overflowY === 'scroll' || overflowY === 'overlay') &&
      el.scrollHeight > el.clientHeight
    ) {
      el.scrollTop = 0
    }
    el = el.parentElement
  }

  if (tableScrollBoxEl) {
    tableScrollBoxEl.scrollTop = 0
    if (typeof tableScrollBoxEl.scrollTo === 'function') {
      tableScrollBoxEl.scrollTo({
        top: 0,
        left: tableScrollBoxEl.scrollLeft,
        behavior: 'auto',
      })
    }
  }
  if (tableContainerEl) {
    const left = tableContainerEl.scrollLeft
    tableContainerEl.scrollTop = 0
    if (typeof tableContainerEl.scrollTo === 'function') {
      tableContainerEl.scrollTo({ top: 0, left, behavior: 'auto' })
    }
  }
}

const getStatusColorAndLabel = (status) => {
  switch (status) {
    // case 0:
    //   return { color: 'warning', label: 'Order Approved' };
    case 1:
      return { color: 'warning', label: 'Status : Received' };
    case 2:
      return { color: 'success', label: 'Status : Paid' };
    default:
      return { color: 'info', label: 'Status: Open' };
  }
};

const getPaymentMode = (mode) => {
  switch (mode) {
    case 1:
      return {label: 'Cash' };
    case 2:
      return {label: 'Check' }; // Cheque
    case 3:
      return {label: 'Debit Card' };
    case 4:
      return {label: 'Credit Card' };
    case 5:
      return {label: 'Consignment' };
    default:
      return { label:'' };
  }
};

const paymentTypes = [
  {id:1,  name: 'Cash'},
  {id:2,  name: 'Check'}, // Cheque
  {id:3,  name: 'Debit Card'},
  {id:4,  name: 'Credit Card'},
  {id:5,  name: 'Consignment'},
]
const ACCOUNT_TABS = [
  {
    value: 'All',
    name: 'All',
  },
  {
    value: 'Open',
    name: 'Open',
  },
  {
    value: 'Received',
    name: 'Received',
  },
  {
    value: 'Paid',
    name: 'Paid',
  },
]


export default function ReceiveOrderList({clientId,hasViewCostPermission=true}) {
  const theme = useTheme();
  const dispatch = useDispatch();
  // Aliased to avoid shadowing the static COMPANY_NAME import; used only for the Purchase Order modal header so it matches PurchaseOrderInvoicePage.js (line 29-31, 52) where the company name comes from useCompanyProfile (active workspace) instead of the static fallback constant.
  const { COMPANY_NAME: companyProfileName } = useCompanyProfile();
  const [loading, setLoading] = useState(true)
  const [loading2, setLoading2] = useState(false)
  const [page, setPage] = useState(0);
  const locationState = useLocation()
  const newTab = locationState.state?.newTab
  const [order, setOrder] = useState('desc');
  const [selected, setSelected] = useState([]);
  const [selectedNames, setSelectedNames] = useState([]);
  const [orderBy, setOrderBy] = useState('id');
  const [filterName, setFilterName] = useState('');
  const [rowsPerPage, setRowsPerPage] = useState(25);
  const [ProductList, setProductList] = useState([]);
  const [viewOrder, setViewOrder] = useState(false);
  const [receivePreview, setReceivePreview] = useState(false);
  const [invoicePreview, setInvoicePreview] = useState(false);
  const [paymentOpen, setPaymentOpen] = useState(false);
  const [refreshData, setRefreshData] = useState(false);
  const [orderId, setOrderId] = useState();
  const [orderPreviewData, setOrderPreviewData] = useState([]);
  const [orderServices, setOrderServices] = useState([]);
  const [invoice, setInvoice] = useState(null);
  const location = useLocation();
  const receivedData = location.state?.data;
  const [openEmailModal, setOpenEmailModal] = useState(false);
  const userData = JSON.parse(localStorage.getItem('user'))
  const userId = userData.user_id
  const [data, setData] = useState({});
  const userType = userData.user_type
  const explodedPermissions =userData?.exploded_permissions
  const canViewCosts = !!hasViewCostPermission
  const { enqueueSnackbar } = useSnackbar();
  const componentRef = useRef();
  const inlinePrintRef = useRef();
  const [inlinePrintOrderId, setInlinePrintOrderId] = useState(null);
  const [inlinePrintData, setInlinePrintData] = useState({ orderPreviewData: [], invoice: null, orderServices: [] });
  const [inlineEmailOrderId, setInlineEmailOrderId] = useState(null);
  const [inlineEmailData, setInlineEmailData] = useState({ orderPreviewData: [], invoice: null, orderServices: [] });
  const [selectedPaymentMode, setSelectedPaymentMode] = useState(null);
  const [validSelection, setValidSelection] = useState(true);
  const tableContainerRef = useRef(null);
  const tableScrollBoxRef = useRef(null);
  const paginationScrollAnchorRef = useRef(null);
  const skipPaginationScrollRef = useRef(true);
  const prevLoadingForPaginationScrollRef = useRef(loading);
  const [currentTab, setCurrentTab] = useState(newTab || 'All')
  const [whereCondition, setWhereCondition] = useState('');
  const handleChangeTab = (event,newValue) => {
    console.log('newValue+++++++', newValue)
    if(newValue==='Open'){
      setWhereCondition('ro.status=0')
    }else if(newValue==='Received'){
      setWhereCondition('ro.status=1')
    }else if(newValue==='Paid'){
      setWhereCondition('ro.status=2')
    }else{
      setWhereCondition('')
    }
    setCurrentTab(newValue);
    setPage(0);
  };

  const fetchDetails = async () => {
    try {
      const res = await axios.post(`${REST_API_END_POINT}settings/get-companyProfile-details`);
      if (res.data.status === 1) {
        setData(...res.data.data);
      }
    } catch (error) {
      console.log('get-companyProfile-details error : ', error);
    }
  };

  useEffect(() => {
    fetchDetails();
  }, []);

  // const [rows, setRows] = useState([{ paymentMode: '', amount: 0 }]);


  // useEffect(() => {
  //   let total = 0;
  //   rows.forEach((row) => {
  //     total += parseFloat(row.amount);
  //   });
  //   if(total >= 0){
  //     setTotalAmount(total);
  //   }else{
  //     setTotalAmount(0);
  //   }
  // }, [rows]);

  useEffect(() => {
    dispatch(getUserList());
  }, [dispatch]);

  useEffect( async () => {
    try {
      setLoading(true)
      const response = await axios.post(`${REST_API_END_POINT}product/get-all-receive-orders-latest-first`,{userType,userId,where:whereCondition});
      if(response.data.status === 1){
        setProductList(response?.data?.orderData);
      }
      else{
        setProductList([]);
      }
    }
      catch (error) {
      console.error("Error fetching data:", error);
    }
    finally{
      setLoading(false);
    }
  }, [receivedData, refreshData,whereCondition]);

  useLayoutEffect(() => {
    if (skipPaginationScrollRef.current) {
      skipPaginationScrollRef.current = false
      return
    }
    const run = () =>
      scrollReceiveOrderListPaginationToTop(
        paginationScrollAnchorRef.current,
        tableScrollBoxRef.current,
        tableContainerRef.current
      )
    run()
    requestAnimationFrame(() => {
      requestAnimationFrame(run)
    })
  }, [page, rowsPerPage])

  useEffect(() => {
    const prev = prevLoadingForPaginationScrollRef.current
    prevLoadingForPaginationScrollRef.current = loading
    if (prev !== true || loading !== false) return
    const run = () =>
      scrollReceiveOrderListPaginationToTop(
        paginationScrollAnchorRef.current,
        tableScrollBoxRef.current,
        tableContainerRef.current
      )
    run()
    requestAnimationFrame(() => {
      requestAnimationFrame(run)
    })
  }, [loading])

  const tableMaxHeight = useTableMaxHeight(
    tableScrollBoxRef,
    [loading, ProductList?.length, rowsPerPage, page, currentTab]
  );

  const fetchOrderById = async () => {
    setLoading(true)
    try{
      const response = await axios.post(`${REST_API_END_POINT}product/get-order-by-id`,{orderId, noStatusCheck:true});
      if(response.data.status === 1){
        setOrderPreviewData(response.data.orderData)
        setOrderServices(response.data.orderServices || [])
        setInvoice(response.data.prodData)
      }
      else{
        setOrderPreviewData([])
        setOrderServices([])
      }
    }catch(error){
      console.log(error);
    }
    finally{
      setLoading(false)
    }
  }

  const LabelStyleHead = styled(Typography)(({ theme }) => ({
    ...theme.typography.h5,
    color: theme.palette.text.primary,
  }))

  const getOrderTypeLabel = (orderType) => {
    if (orderType == 1) return 'Materials';
    if (orderType == 2) return 'Stock Catalogs';
    if (orderType == 3) return 'Service Only';
    return 'Materials'; // default
  }

  useEffect(()=>{
    if(orderId){
      fetchOrderById()
    }
  },[orderId,receivePreview,invoicePreview,paymentOpen,viewOrder])

  // Fetch order data for inline print
  const fetchOrderForInlinePrint = async (id) => {
    try {
      setInlinePrintOrderId(id);
      const response = await axios.post(`${REST_API_END_POINT}product/get-order-by-id`, { orderId: id, noStatusCheck: true });
      if (response.data.status === 1) {
        setInlinePrintData({
          orderPreviewData: response.data.orderData,
          invoice: response.data.prodData,
          orderServices: response.data.orderServices || [],
        });
      }
      // Small delay to let the component render with new data
      await new Promise((r) => setTimeout(r, 300));
    } catch (error) {
      console.log(error);
    }
  };

  // Fetch order data for inline email
  const fetchOrderForInlineEmail = async (id) => {
    try {
      const response = await axios.post(`${REST_API_END_POINT}product/get-order-by-id`, { orderId: id, noStatusCheck: true });
      if (response.data.status === 1) {
        setInlineEmailData({
          orderPreviewData: response.data.orderData,
          invoice: response.data.prodData,
          orderServices: response.data.orderServices || [],
        });
        setInlineEmailOrderId(id);
        setOpenEmailModal(true);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const handleInlineEmail = (id) => {
    fetchOrderForInlineEmail(id);
  };

  // ...
  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };

  const handleSelectAllClick = (event) => {
    if (event.target.checked) {
      const newSelecteds = slicedData?.map((n) => n.id);
      const newSelectedNames = slicedData?.map((n) => n.name);
      setSelected(newSelecteds);
      setSelectedNames(newSelectedNames);
      return;
    }
    setSelected([]);
    setSelectedNames([]);
  };

  const handleClick = (event, id,name) => {
    const selectedIndex = selected?.indexOf(id);
    const selectedNameIndex = selectedNames?.indexOf(name);
    let newSelected = [];
    let newselectedNames = [];
    if (selectedIndex === -1) {
      newSelected = newSelected?.concat(selected, id);
      newselectedNames = newselectedNames?.concat(selectedNames, name);
    } else if (selectedIndex === 0) {
      newSelected = newSelected?.concat(selected?.slice(1));
      newselectedNames = newselectedNames?.concat(selectedNames?.slice(1));
    } else if (selectedIndex === selected?.length - 1) {
      newSelected = newSelected?.concat(selected?.slice(0, -1));
      newselectedNames = newselectedNames?.concat(selectedNames?.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected?.concat(selected?.slice(0, selectedIndex), selected?.slice(selectedIndex + 1));
      newselectedNames = newselectedNames?.concat(selectedNames?.slice(0, selectedNameIndex), selectedNames?.slice(selectedNameIndex + 1));
    }
    setSelected(newSelected);
    setSelectedNames(newselectedNames);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
    setSelected([]);
    setSelectedNames([]);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleFilterByName = (event) => {
    setFilterName(event.target.value);
  };

  const handleDeleteUser = (userId) => {
    dispatch(deleteUser(userId));
  };

  const handleReceiveOrder = async () => {
   try {
    setLoading2(true); 
    
  
    const data={};
    data['status'] = 1
    const response = await axios.post(`${REST_API_END_POINT}products/update-receive-order`,{orderId,data,userId,orderPreviewData})
    if(response.data.status === 1){
      enqueueSnackbar(`Order received successfully`, { variant: 'success' });
    }
    else{
      enqueueSnackbar(`Error receiving order`, { variant: 'error' });
    }
    setRefreshData(!refreshData)
    setReceivePreview(false)
    // setLoading2(false);
  } catch (error) {
    console.log(error)
    // setLoading2(false);
  }finally{
    setLoading2(false);
  }
  };


  const handleReceivePayment = async () => {
    try{
      setLoading2(true); 
    if(selectedPaymentMode){
      const data={};
      data['payment_status'] = 1;
      data['status'] = 2
      data['payment_mode'] = selectedPaymentMode
      const response = await axios.post(`${REST_API_END_POINT}products/update-receive-order`,{orderId,data,userId})
      if(response.data.status === 1){
        enqueueSnackbar(`Payment submitted successfully`, { variant: 'success' });
      }
      else{
        enqueueSnackbar(`Error adding payment`, { variant: 'error' });
      }
      setRefreshData(!refreshData)
      setPaymentOpen(false)
      setSelectedPaymentMode(null)
      setValidSelection(true)
    }else{
      setValidSelection(false)
    }
  }catch(error){
    console.log(error)
  }finally{
    setLoading2(false);
  }
  };

  const RowResultStyle = styled(TableRow)(({ theme }) => ({
    '& td': {
      paddingTop: theme.spacing(1),
      paddingBottom: theme.spacing(1),
    },
  }))

  // const handleAddRow = () => {
  //   setRows([...rows, { paymentMode: null, amount: 0 }]);
  // };

  // const handleDeleteRow = (index) => {
  //   const updatedRows = [...rows];
  //   updatedRows.splice(index, 1);
  //   setRows(updatedRows);
  // };

  // const handlePaymentModeChange = (event, index) => {
  //   const updatedRows = [...rows];
  //   updatedRows[index].paymentMode = event.target.value;
  //   setRows(updatedRows);
  // };

  // const handleAmountChange = (event, index) => {
  //   const updatedRows = [...rows];
  //   updatedRows[index].amount = event.target.value;
  //   setRows(updatedRows);
  // }; ProductList.filter(item => item.qty > 0)
  const emptyRows = page > 0 ? Math.max(0, (1 + page) * rowsPerPage - ProductList.length) : 0;
  const filteredUsers = applySortFilter((clientId ? ProductList?.filter(val=>val.vendor_id === clientId) : ProductList), getComparator(order, orderBy), filterName);
  const slicedData = filteredUsers?.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage);
  const isUserNotFound = filteredUsers.length === 0;
  const invoiceDate = orderPreviewData[0]?.received_date
    ? moment(orderPreviewData[0].received_date * 1000).format('MM/DD/YYYY')
    : orderPreviewData[0]?.timestamp
    ? moment(orderPreviewData[0].timestamp * 1000).format('MM/DD/YYYY')
    : moment().format('MM/DD/YYYY');

  const inlineInvoiceDate = inlinePrintData.orderPreviewData[0]?.received_date
    ? moment(inlinePrintData.orderPreviewData[0].received_date * 1000).format('MM/DD/YYYY')
    : inlinePrintData.orderPreviewData[0]?.timestamp
    ? moment(inlinePrintData.orderPreviewData[0].timestamp * 1000).format('MM/DD/YYYY')
    : moment().format('MM/DD/YYYY');


  const handleScrollLeft = () => {
    tableContainerRef.current.scrollTo({
      left: 0,
      behavior: 'smooth'
    });
  };
  
  const handleScrollRight = () => {
    tableContainerRef.current.scrollTo({
      left: tableContainerRef.current.scrollWidth,
      behavior: 'smooth'
    });
  };

  return (
      <Container className="receive-order-list-table-head-fix">
        {/* OLD PAGE CONTAINER (table header first/last cells kept default rounded gaps) - kept for backup */}
        {/* <Container> */}
        {/* NEW PAGE CONTAINER - scoped class removes start/end gaps from table heads on this page */}
        {/* OLD TABLE-HEAD GAP FIX (scoped only to .receive-order-list-table-head-fix; missed modal tables because Dialog portal mounts outside this Container in the DOM) - kept for backup */}
        {/* <style>
          {`
            .receive-order-list-table-head-fix .MuiTableHead-root .MuiTableCell-head:first-of-type {
              border-top-left-radius: 0 !important;
              border-bottom-left-radius: 0 !important;
            }
            .receive-order-list-table-head-fix .MuiTableHead-root .MuiTableCell-head:last-of-type {
              border-top-right-radius: 0 !important;
              border-bottom-right-radius: 0 !important;
            }
            .receive-order-list-table-head-fix .MuiTableHead-root .MuiTableCell-head {
              background-clip: border-box !important;
            }
          `}
        </style> */}
        {/* PREVIOUS TABLE-HEAD GAP FIX (only zeroed border-radius; the real gap came from the theme's `box-shadow: inset 8px 0 0 background.paper` on first/last head cells + extra paddingLeft/paddingRight of theme.spacing(3), neither of which were overridden) - kept for backup */}
        {/* <style>
          {`
            .receive-order-list-table-head-fix .MuiTableHead-root .MuiTableCell-head:first-of-type,
            .MuiDialog-paper .MuiTableHead-root .MuiTableCell-head:first-of-type {
              border-top-left-radius: 0 !important;
              border-bottom-left-radius: 0 !important;
            }
            .receive-order-list-table-head-fix .MuiTableHead-root .MuiTableCell-head:last-of-type,
            .MuiDialog-paper .MuiTableHead-root .MuiTableCell-head:last-of-type {
              border-top-right-radius: 0 !important;
              border-bottom-right-radius: 0 !important;
            }
            .receive-order-list-table-head-fix .MuiTableHead-root .MuiTableCell-head,
            .MuiDialog-paper .MuiTableHead-root .MuiTableCell-head {
              background-clip: border-box !important;
            }
          `}
        </style> */}
        {/* NEW TABLE-HEAD GAP FIX - also overrides the inset box-shadow + extra paddingLeft/Right that the global MuiTableCell theme override adds to first/last head cells. Scoped to this page container AND to .MuiDialog-paper so it reaches the View Order / Receive Order / Purchase Order modals which render through a Dialog portal. Make Payment modal uses <TableBody> for its header row (not <TableHead>) so it's unaffected. */}
        <style>
          {`
            .receive-order-list-table-head-fix .MuiTableHead-root .MuiTableCell-head:first-of-type,
            .MuiDialog-paper .MuiTableHead-root .MuiTableCell-head:first-of-type {
              border-top-left-radius: 0 !important;
              border-bottom-left-radius: 0 !important;
              box-shadow: none !important;
              padding-left: 16px !important;
            }
            .receive-order-list-table-head-fix .MuiTableHead-root .MuiTableCell-head:last-of-type,
            .MuiDialog-paper .MuiTableHead-root .MuiTableCell-head:last-of-type {
              border-top-right-radius: 0 !important;
              border-bottom-right-radius: 0 !important;
              box-shadow: none !important;
              padding-right: 16px !important;
            }
            .receive-order-list-table-head-fix .MuiTableHead-root .MuiTableCell-head,
            .MuiDialog-paper .MuiTableHead-root .MuiTableCell-head {
              background-clip: border-box !important;
            }
          `}
        </style>
        <Card>
        <Stack direction="row" spacing={1} justifyContent="center" alignItems="start" paddingY={0.5} paddingX={1.5}>        <Tabs
                value={currentTab}
                scrollButtons="auto"
                variant="scrollable"
                allowScrollButtonsMobile
                onChange={handleChangeTab}

              >
                {ACCOUNT_TABS.map((tabItem) => (
                  <Tab
                    sx={{
                      justifyContent: 'center', marginX: 15, mt: 2.5
                    }}
                    disableRipple
                    key={tabItem.value}
                    label={
                      // <Badge badgeContent={tabItem.count} color="primary">
                      <Typography variant='h6'>{capitalCase(tabItem.name)}</Typography>
                      // </Badge>
                    }
                    // icon={tabItem.icon}
                    value={tabItem.value}
                  />
                ))}
              </Tabs> 
              </Stack>
          <MaterialInventoryToolbar 
            numSelected={selected?.length} 
            filterName={filterName} 
            onFilterName={handleFilterByName} 
            selectedName={selectedNames} 
            selected={selected} 
            onDelete={() => {setSelected([]);setPage(0);}}
            item="Purchase Orders"
          />
{/* <Stack direction="row" spacing={1} justifyContent="center" alignItems="start" p={2.5}>
          <Button >Pre-Production</Button>
          <Button >Pre-Production</Button>
        </Stack> */}
        
          <Box ref={paginationScrollAnchorRef}>
          <Box
            ref={tableScrollBoxRef}
            sx={{
              maxHeight: tableMaxHeight,
              overflowY: 'auto',
              overflowX: 'hidden',
              width: '100%',
              '&::-webkit-scrollbar': {
                width: '0.6em',
                height: '0.6em',
              },
              '&::-webkit-scrollbar-track': {
                background: '#1e1e1e',
                borderRadius: '4px',
              },
              '&::-webkit-scrollbar-thumb': {
                backgroundColor: '#555',
                borderRadius: '6px',
                border: '2px solid #1e1e1e',
              },
              '&::-webkit-scrollbar-thumb:hover': {
                backgroundColor: '#888',
              },
              '&::-webkit-scrollbar-corner': {
                backgroundColor: '#1e1e1e',
              },
            }}
          >
            <TableContainer
              ref={tableContainerRef}
              sx={{
                minWidth: 800,
                whiteSpace: 'nowrap',
                overflowX: 'auto',
                '&::-webkit-scrollbar': {
                  width: '0.6em',
                  height: '0.6em',
                },
                '&::-webkit-scrollbar-track': {
                  background: '#1e1e1e',
                  borderRadius: '4px',
                },
                '&::-webkit-scrollbar-thumb': {
                  backgroundColor: '#555',
                  borderRadius: '6px',
                  border: '2px solid #1e1e1e',
                },
                '&::-webkit-scrollbar-thumb:hover': {
                  backgroundColor: '#888',
                },
                '&::-webkit-scrollbar-corner': {
                  backgroundColor: '#1e1e1e',
                },
              }}
            >
              <Table 
                stickyHeader
                sx={{
                  '& .MuiTableCell-head': {
                    padding: '8px 12px',
                    fontSize: '0.75rem',
                    fontWeight: 600,
                    height: 'auto',
                    minHeight: '48px',
                    lineHeight: 1.4,
                    whiteSpace: 'pre-line',
                    textAlign: 'left',
                    verticalAlign: 'middle'
                  },
                  '& .MuiTableSortLabel-root': {
                    fontSize: '0.75rem',
                    fontWeight: 600,
                    justifyContent: 'flex-start',
                    whiteSpace: 'pre-line',
                    '& .MuiTableSortLabel-icon': {
                      marginLeft: '4px'
                    }
                  }
                }}
              >
              <UserListHead
                  order={order}
                  orderBy={orderBy}
                  headLabel={TABLE_HEAD}
                  rowCount={slicedData?.length}
                  numSelected={selected?.length}
                  onRequestSort={handleRequestSort}
                  onSelectAllClick={handleSelectAllClick}
                  showIdLabel=''
                  showId='id'
                />
                
                <TableBody>
                {loading ? (
                  <TableRow>
                    <TableCell align="center" colSpan={11} sx={{ py: 5 }}>
                      <Stack direction="row" spacing={2} alignItems="center" justifyContent="center">
                        <CircularProgress color="primary" variant="indeterminate" size={40} />
                        <Typography variant="body2" color="text.secondary">Loading orders...</Typography>
                      </Stack>
                    </TableCell>
                  </TableRow>
                ) : (
                  <>
                  {slicedData?.map((row) => {
                    let { id,name, timestamp, status, authorized_by, vendor_name, received_date, expected_date, payment_mode, payment_status,syncWithQuickbooks,doc_number } = row;
                    const isItemSelected = selected?.indexOf(id) !== -1;
                    return (
                      <TableRow
                        hover
                        key={id}
                        tabIndex={-1}
                        role="checkbox"
                        selected={isItemSelected}
                        aria-checked={isItemSelected}
                        sx={{
                          '& .MuiTableCell-root': {
                            padding: '8px 12px',
                            fontSize: '0.75rem',
                            height: 'auto',
                            lineHeight: 1.4
                          }
                        }}
                      >

                        <TableCell padding="checkbox" align="left" onClick={handleScrollRight} sx={{ padding: '8px 4px !important', width: '40px' }}>
                          <IconButton sx={{ backgroundColor: theme.palette.divider, width: "28px", height: "28px", padding: 0 }} >
                            <ArrowForwardIos color="#ffffff" sx={{ width: "16px", fontSize: '0.875rem' }}/>
                          </IconButton>
                        </TableCell>
                        <TableCell align="left" sx={{ maxWidth: '28px', fontSize: '0.75rem' }}>
                          {id} 
                        </TableCell>
                        <TableCell align="left" sx={{ padding: '8px 20px !important' }}>
                          {syncWithQuickbooks?
                          <Stack sx={{display:"flex",flexDirection:"row", alignItems:"center"}}>
                            <Avatar src={QuickbookLogo} sx={{width:24,height:24,objectFit:"cover"}}/>
                            <Typography sx={{fontSize:"0.75rem",ml:0.5}}>{`#${doc_number}`}</Typography>
                          </Stack>
                          :"N/A"}
                        </TableCell>
                        <TableCell align="center" sx={{ cursor: 'pointer',textAlign: 'left' }}>
                          <Tooltip title={name}>
                            <Typography
                              variant="subtitle2"
                              noWrap
                              sx={{
                                cursor: 'pointer',
                                maxWidth: {xs: 300, sm: 100, md: 100, lg: 100, xl: 440},
                                overflow: 'hidden',
                                textOverflow: 'ellipsis',
                                whiteSpace: 'nowrap',
                                fontWeight: 500,
                                fontSize: '0.75rem',
                              }}
                              onClick={()=>{setViewOrder(true);setOrderId(id);}}
                            >
                              {name}
                            </Typography>
                          </Tooltip>
                        </TableCell>
                        <TableCell align="left" sx={{ maxWidth: {xs: 300, sm: 100, md: 100, lg: 100, xl: 440}, p: 0 }}>
                          <Tooltip title={vendor_name || ''}>
                            <Typography
                              variant="body2"
                              noWrap
                              sx={{
                                fontSize: '0.75rem',
                                maxWidth: '100%',
                                overflow: 'hidden',
                                textOverflow: 'ellipsis',
                                whiteSpace: 'nowrap',
                                cursor: 'pointer',
                              }}
                            >
                              {vendor_name}
                            </Typography>
                          </Tooltip>
                        </TableCell>
                        <TableCell align="left" sx={{ fontSize: '0.75rem' }}>{formatDateOnly(received_date)}</TableCell>
                        {/* <TableCell align="left" sx={{ fontSize: '0.75rem' }}>{moment.unix(expected_date).format('MM/DD/YYYY')}</TableCell> */}
                        {/* <TableCell align="left" sx={{ fontSize: '0.75rem' }}>{payment_mode && getPaymentMode(payment_mode).label || "N/A"}</TableCell> */}
                        <TableCell align="left" sx={{ fontSize: '0.75rem' }}>{(payment_status === 1) ? 'Paid' : 'Unpaid'}</TableCell>
                        {/* <TableCell align="center">{authorized_by}</TableCell>
                        <TableCell align="center">{moment.unix(timestamp).format('MM-DD-YYYY')}</TableCell> */}
                        <TableCell align="left" sx={{ fontSize: '0.75rem' }}>
                          <Label
                            variant={theme.palette.mode === 'light' ? 'ghost' : 'filled'}
                            color={(status === 2) ? "success" : ((status === 1) ? "warning" : "info")}
                          >
                            {sentenceCase((status === 2) ? "Paid" : ((status === 1) ? "Received" : "Open"))}
                          </Label>
                        </TableCell>

                        <TableCell align="left" sx={{ padding: '4px 8px !important' }}>
                          <Stack direction="row" spacing={0.5} alignItems="center">
                            <ReactToPrint
                              trigger={() => (
                                <Tooltip title="Print">
                                  <IconButton
                                    size="small"
                                    sx={{ width: 28, height: 28 }}
                                    disabled={inlinePrintOrderId === id}
                                  >
                                    <Print sx={{ fontSize: '1rem' }} />
                                  </IconButton>
                                </Tooltip>
                              )}
                              content={() => inlinePrintRef.current}
                              onBeforeGetContent={() => fetchOrderForInlinePrint(id)}
                              onAfterPrint={() => setInlinePrintOrderId(null)}
                              pageStyle={`
                                @page {
                                  size: A3;
                                  margin: 12mm;
                                }
                                body {
                                  font-family: 'Public Sans', sans-serif;
                                  font-size: 12pt;
                                }
                                table {
                                  width: 100%;
                                  border-collapse: collapse;
                                }
                              `}
                            />
                            <Tooltip title="Email">
                              <IconButton
                                size="small"
                                sx={{ width: 28, height: 28 }}
                                onClick={() => handleInlineEmail(id)}
                              >
                                <EmailOutlined sx={{ fontSize: '1rem' }} />
                              </IconButton>
                            </Tooltip>
                          </Stack>
                        </TableCell>

                        <TableCell align="left">
                        {clientId ? '' : userType == 3 ?
                        <ReceiveOrderMenu 
                          userName={name} 
                          id={id} 
                          userType={userType}
                          status={status} 
                          onRefresh={()=>{setRefreshData(!refreshData)}}  
                          onInvoice={(id)=>{setOrderId(id); setInvoicePreview(true);}}
                        />
                         :
                          <ReceiveOrderMenu 
                          onDelete={() => handleDeleteUser(id)} 
                          userName={name} 
                          id={id} 
                          status={status} 
                          onReceive={(id)=>{setOrderId(id); setReceivePreview(true);}} 
                          onRefresh={()=>{setRefreshData(!refreshData)}}  
                          onInvoice={(id)=>{setOrderId(id); setInvoicePreview(true);}} 
                          hasViewCostPermission={canViewCosts} 
                          onPayment={(id)=>{setOrderId(id); setPaymentOpen(true);}}/>
                        }
                        </TableCell>

                        <TableCell padding="checkbox" align="left" onClick={handleScrollLeft} sx={{ padding: '8px 4px !important', width: '40px' }}>
                          <IconButton sx={{ backgroundColor: theme.palette.divider, width: "28px", height: "28px", padding: 0 }} >
                            <ArrowBackIos color="#ffffff" sx={{ width: "16px", ml: 0.5, fontSize: '0.875rem' }}/>
                          </IconButton>
                        </TableCell>
                      </TableRow>
                    );
                  })}
                  {emptyRows > 0 && (
                    <TableRow style={{ height: 53 * emptyRows }}>
                      <TableCell colSpan={6} />
                    </TableRow>
                  )}
                  </>
                    )}
                </TableBody>
                {(isUserNotFound && !loading) && (
                  <TableBody>
                    <TableRow>
                      <TableCell align="center" colSpan={9} sx={{ py: 3 }}>
                        <SearchNotFound searchQuery={filterName} msg="Purchase orders"/>
                      </TableCell>
                    </TableRow>
                  </TableBody>
                )}
              </Table>
            </TableContainer>
          </Box>

          <TablePagination
            rowsPerPageOptions={[25, 50, 100, 500]}
            component="div"
            count={filteredUsers?.length}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />
          </Box>
        </Card>

        {receivePreview && (
          <Modal
            open={receivePreview}
            handleClose={() => {
              setReceivePreview(false);
            }}
            width="800px"
            modalTitle={orderPreviewData[0]?.order_status === 0 ? `Receive Order - ${orderPreviewData[0]?.order_name || ''}` : `View Order - ${orderPreviewData[0]?.order_name || ''}`}
          >
            {loading ? ( 
              <Stack alignItems='center' justifyContent='center'>
                <CircularProgress color="primary" variant="indeterminate" />
              </Stack>
             ) : (
              <>
                <Grid container sx={{ justifyContent: 'center' }} spacing={3}>
                  <Grid item xs={12} md={10}>
                    <Stack
                      sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        justifyContent: 'space-between',
                      }}
                      spacing={3}
                    >
                      <Stack
                        direction={{ xs: 'column', md: 'column' }} 
                        display="flex"
                        justifyContent="space-between"
                        spacing={3}
                      >
                        <Stack direction={{ xs: 'column', md: 'column' }}>
                        {/* <Typography variant="body">
                        Order ID: <span style={{ color:theme.palette.primary.dark, fontWeight:'bold' }}>{orderPreviewData[0]?.order_id}</span>
                        </Typography> */}
                        <Typography variant="body">
                          Order Name: <span style={{ color:theme.palette.primary.dark, fontWeight:'bold' }}>{orderPreviewData[0]?.order_name}</span>
                        </Typography>

                        <Typography variant="subtitle1">
                          Vendor : <span style={{ color:theme.palette.primary.dark, fontWeight:'bold' }}>{orderPreviewData[0]?.vendor_name?orderPreviewData[0]?.vendor_name : ""}</span>
                        </Typography>
                        <Typography variant="subtitle1">
                          Qb Id : <span style={{ color:theme.palette.primary.dark, fontWeight:'bold' }}>{orderPreviewData[0]?.doc_number? `#${orderPreviewData[0]?.doc_number}` : ""}</span>
                        </Typography>
                        <Typography variant="subtitle1">
                          Date Expected : <span style={{ color:theme.palette.primary.dark, fontWeight:'bold' }}>{orderPreviewData[0]?.expected_date && orderPreviewData[0]?.expected_date > 0 ? formatDateOnly(orderPreviewData[0]?.expected_date) : "N/A"}</span>
                        </Typography>
                        <Typography variant="subtitle1">
                          Payment Mode : <span style={{ color:theme.palette.primary.dark, fontWeight:'bold' }}>{orderPreviewData[0]?.payment_mode && orderPreviewData[0]?.payment_mode > 0 ? (getPaymentMode(orderPreviewData[0]?.payment_mode).label || "N/A") : "N/A"}</span>
                        </Typography>
                        <Typography variant="subtitle1">
                          Order Type : <span style={{ color:theme.palette.primary.dark, fontWeight:'bold' }}>{getOrderTypeLabel(orderPreviewData[0]?.orderType)}</span>
                        </Typography>
                        <Typography variant="subtitle1">
                          Classification : <span style={{ color:theme.palette.primary.dark, fontWeight:'bold' }}>{orderPreviewData[0]?.project_type_name || "N/A"}</span>
                        </Typography>

                        <Grid item xs={12} sm={6} sx={{ mb: 5 }}>
                        <Label
                          variant={theme.palette.mode === 'light' ? 'ghost' : 'filled'}
                          color={getStatusColorAndLabel(orderPreviewData[0]?.order_status).color} >
                          {getStatusColorAndLabel(orderPreviewData[0]?.order_status).label}
                        </Label>
                        </Grid>

                        {/* {orderPreviewData[0]?.orderType !== 3 && ( */}
                        <Typography variant="subtitle2" sx={{ mt:2, color: `${(orderPreviewData[0]?.syncWithQuickbooks==1) ? 'green' : 'red'}` }}>
                        {(orderPreviewData[0]?.notSyncedMessage 
                          // ? orderPreviewData[0]?.notSyncedMessage.split('\n').map((line, index) => (
                          //   <span key={index} style={{ display: 'block' }}>{line}</span>
                          // )) 
                         ? <div dangerouslySetInnerHTML={{ __html: orderPreviewData[0]?.notSyncedMessage.replace(/\n/g, '<br />') }} />
                          : ((orderPreviewData[0]?.syncWithQuickbooks==1 ) ? 
                          'Successfully Synced With QuickBooks' :
                          ''))}
                          {/* 'Not Synced With QuickBooks.'))} */}
                         
                        </Typography>
                        {/* )} */}
                        </Stack>

                        {/* Materials Section */}
                        {orderPreviewData?.filter(item => item.meterial == 1).length > 0 && (
                          <>
                            <Typography variant="h6" sx={{ mt: 2, mb: 1, fontWeight: 'bold' }}>
                              Materials
                            </Typography>
                            <Scrollbar>
                              {/* OLD TABLE CONTAINER (native scrollbar) - kept for backup */}
                              {/* <TableContainer sx={{ maxWidth: '100%', border: '1px solid', borderColor: theme.palette.divider}}> */}
                              {/* NEW TABLE CONTAINER - theme-matched custom scrollbar */}
                              <TableContainer sx={{
                                maxWidth: '100%',
                                border: '1px solid',
                                borderColor: theme.palette.divider,
                                '&::-webkit-scrollbar': { height: 8, width: 8 },
                                '&::-webkit-scrollbar-track': { backgroundColor: theme.palette.background.paper },
                                '&::-webkit-scrollbar-thumb': { backgroundColor: theme.palette.divider, borderRadius: 4 },
                                '&::-webkit-scrollbar-thumb:hover': { backgroundColor: theme.palette.text.disabled },
                                scrollbarWidth: 'thin',
                                scrollbarColor: `${theme.palette.divider} ${theme.palette.background.paper}`
                              }}>
                                {/* OLD MATERIALS TABLE (body cells had no border) - kept for backup */}
                                {/* <Table> */}
                                {/* NEW MATERIALS TABLE - cell borders applied to all cells (headers + body) */}
                                <Table sx={{ '& .MuiTableCell-root': { border: '1px solid', borderColor: theme.palette.divider } }}>
                                <TableHead sx={{ width: '100%'}}>
                                  <TableRow>
                                    {/* OLD MATERIALS HEADERS - kept for backup */}
                                    {/* <TableCell align='center' sx={{ border: '1px solid',borderColor:theme.palette.divider }}>#</TableCell> */}
                                    {/* <TableCell align='center' sx={{ border: '1px solid',borderColor:theme.palette.divider }}>Product Name</TableCell> */}
                                    {/* <TableCell align='center' sx={{ border: '1px solid',borderColor:theme.palette.divider }}>Service Name</TableCell> */}
                                    {/* {canViewCosts && <TableCell align='center' sx={{ border: '1px solid',borderColor:theme.palette.divider }}>Unit Cost</TableCell>} */}
                                    {/* <TableCell align='center' sx={{ border: '1px solid',borderColor:theme.palette.divider }}>Quantity</TableCell> */}
                                    {/* <TableCell align='center' sx={{ border: '1px solid',borderColor:theme.palette.divider }}>Shipping Cost</TableCell> */}
                                    {/* {canViewCosts && <TableCell align='center' sx={{ border: '1px solid',borderColor:theme.palette.divider }}>Service Cost</TableCell>} */}
                                    {/* {canViewCosts && <TableCell align='center' sx={{ border: '1px solid',borderColor:theme.palette.divider }}>Total</TableCell>} */}
                                    {/* NEW MATERIALS HEADERS - aligned with Create/Edit Receive Order */}
                                    <TableCell align='center' sx={{ border: '1px solid',borderColor:theme.palette.divider }}>ITEM</TableCell>
                                    {/* OLD MATERIALS DESCRIPTION HEADER (default width) - kept for backup */}
                                    {/* <TableCell align='center' sx={{ border: '1px solid',borderColor:theme.palette.divider }}>DESCRIPTION</TableCell> */}
                                    {/* PREVIOUS MATERIALS DESCRIPTION HEADER (width 22% / minWidth 220) - kept for backup */}
                                    {/* <TableCell align='center' sx={{ border: '1px solid',borderColor:theme.palette.divider, width: '22%', minWidth: 220 }}>DESCRIPTION</TableCell> */}
                                    {/* NEW MATERIALS DESCRIPTION HEADER - widened further per user request for more horizontal room */}
                                    <TableCell align='center' sx={{ border: '1px solid',borderColor:theme.palette.divider, width: '28%', minWidth: 280 }}>DESCRIPTION</TableCell>
                                    <TableCell align='center' sx={{ border: '1px solid',borderColor:theme.palette.divider }}>QTY ORDERED</TableCell>
                                    {canViewCosts && <TableCell align='center' sx={{ border: '1px solid',borderColor:theme.palette.divider }}>UNIT COST</TableCell>}
                                    <TableCell align='center' sx={{ border: '1px solid',borderColor:theme.palette.divider }}>QTY REC'D</TableCell>
                                    <TableCell align='center' sx={{ border: '1px solid',borderColor:theme.palette.divider }}>DELIVERED</TableCell>
                                    <TableCell align='center' sx={{ border: '1px solid',borderColor:theme.palette.divider }}>SERVICE NAME</TableCell>
                                    {canViewCosts && <TableCell align='center' sx={{ border: '1px solid',borderColor:theme.palette.divider }}>SERVICE COST</TableCell>}
                                    {canViewCosts && <TableCell align='center' sx={{ border: '1px solid',borderColor:theme.palette.divider }}>AMOUNT</TableCell>}
                                  </TableRow>
                                </TableHead>
                                  <TableBody>
                                    {orderPreviewData?.filter(item => item.meterial == 1).map((row,index) => {
                                      let { order_name,order_id, vendor_name, product_name,service_name, unit_cost, actual_qty,actual_unit_qty, actual_total_cost,shipping_cost,service_cost,convertion_qty,convertion_unit } = row;
                                      const total_qty = actual_unit_qty * convertion_qty;
                                      const unitName = convertion_unit? UNITS.find(item => item.id == convertion_unit)?.name:'Unit';
                                      const quantity = convertion_unit==4 ?`${actual_unit_qty || 0} ${unitName}` : `${actual_unit_qty || 0}(${total_qty} ${unitName})`;
                                      const productDescription = invoice?.find(p => p?.material_inventory_id === row?.id)?.description || '-';
                                      
                                      return (
                                        <TableRow
                                          hover
                                          key={`material-${index}`}
                                          tabIndex={-1}
                                        >
                                          {/* OLD MATERIALS ROW CELLS - kept for backup */}
                                          {/* <TableCell align="center">{index + 1}</TableCell> */}
                                          {/* <TableCell align="center">{product_name || '-'}</TableCell> */}
                                          {/* <TableCell align="center">{service_name || '-'}</TableCell> */}
                                          {/* {canViewCosts && <TableCell align="center">${unit_cost || 0}</TableCell>} */}
                                          {/* <TableCell align="center">{quantity}</TableCell> */}
                                          {/* <TableCell align="center">{actual_qty || 0}</TableCell> */}
                                          {/* <TableCell align="center">{shipping_cost || 0}</TableCell> */}
                                          {/* {canViewCosts && <TableCell align="center">{service_cost || 0}</TableCell>} */}
                                          {/* {canViewCosts && <TableCell align="center">${actual_total_cost || 0}</TableCell>} */}
                                          {/* NEW MATERIALS ROW CELLS - aligned with Create/Edit Receive Order */}
                                          <TableCell align="center">{product_name || '-'}</TableCell>
                                          <TableCell align="center">{productDescription}</TableCell>
                                          <TableCell align="center">{quantity}</TableCell>
                                          {canViewCosts && <TableCell align="center">${unit_cost || 0}</TableCell>}
                                          <TableCell align="center">{orderPreviewData[0]?.order_status === 0 ? '-' : quantity}</TableCell>
                                          <TableCell align="center">-</TableCell>
                                          <TableCell align="center">{service_name || '-'}</TableCell>
                                          {canViewCosts && <TableCell align="center">{service_cost || 0}</TableCell>}
                                          {canViewCosts && <TableCell align="center">${actual_total_cost || 0}</TableCell>}
                                        </TableRow>
                                      );
                                    })}
                                  </TableBody>
                                </Table>
                              </TableContainer>
                            </Scrollbar>
                          </>
                        )}

                        {/* Catalogs Section */}
                        {orderPreviewData?.filter(item => item.meterial == 0).length > 0 && (
                          <>
                            <Typography variant="h6" sx={{ mt: 2, mb: 1, fontWeight: 'bold' }}>
                              Catalogs
                            </Typography>
                            <Scrollbar>
                              {/* OLD TABLE CONTAINER (native scrollbar) - kept for backup */}
                              {/* <TableContainer sx={{ maxWidth: '100%', border: '1px solid', borderColor: theme.palette.divider}}> */}
                              {/* NEW TABLE CONTAINER - theme-matched custom scrollbar */}
                              <TableContainer sx={{
                                maxWidth: '100%',
                                border: '1px solid',
                                borderColor: theme.palette.divider,
                                '&::-webkit-scrollbar': { height: 8, width: 8 },
                                '&::-webkit-scrollbar-track': { backgroundColor: theme.palette.background.paper },
                                '&::-webkit-scrollbar-thumb': { backgroundColor: theme.palette.divider, borderRadius: 4 },
                                '&::-webkit-scrollbar-thumb:hover': { backgroundColor: theme.palette.text.disabled },
                                scrollbarWidth: 'thin',
                                scrollbarColor: `${theme.palette.divider} ${theme.palette.background.paper}`
                              }}>
                                {/* OLD CATALOGS TABLE (body cells had no border) - kept for backup */}
                                {/* <Table> */}
                                {/* NEW CATALOGS TABLE - cell borders applied to all cells (headers + body) */}
                                <Table sx={{ '& .MuiTableCell-root': { border: '1px solid', borderColor: theme.palette.divider } }}>
                                <TableHead sx={{ width: '100%'}}>
                                  <TableRow>
                                    {/* OLD CATALOGS HEADERS - kept for backup */}
                                    {/* <TableCell align='center' sx={{ border: '1px solid',borderColor:theme.palette.divider }}>#</TableCell> */}
                                    {/* <TableCell align='center' sx={{ border: '1px solid',borderColor:theme.palette.divider }}>Product Name</TableCell> */}
                                    {/* <TableCell align='center' sx={{ border: '1px solid',borderColor:theme.palette.divider }}>Service Name</TableCell> */}
                                    {/* {canViewCosts && <TableCell align='center' sx={{ border: '1px solid',borderColor:theme.palette.divider }}>Unit Cost</TableCell>} */}
                                    {/* <TableCell align='center' sx={{ border: '1px solid',borderColor:theme.palette.divider }}>Quantity</TableCell> */}
                                    {/* <TableCell align='center' sx={{ border: '1px solid',borderColor:theme.palette.divider }}>Shipping Cost</TableCell> */}
                                    {/* {canViewCosts && <TableCell align='center' sx={{ border: '1px solid',borderColor:theme.palette.divider }}>Service Cost</TableCell>} */}
                                    {/* {canViewCosts && <TableCell align='center' sx={{ border: '1px solid',borderColor:theme.palette.divider }}>Total</TableCell>} */}
                                    {/* NEW CATALOGS HEADERS - aligned with Create/Edit Receive Order */}
                                    <TableCell align='center' sx={{ border: '1px solid',borderColor:theme.palette.divider }}>ITEM</TableCell>
                                    {/* OLD CATALOGS DESCRIPTION HEADER (default width) - kept for backup */}
                                    {/* <TableCell align='center' sx={{ border: '1px solid',borderColor:theme.palette.divider }}>DESCRIPTION</TableCell> */}
                                    {/* PREVIOUS CATALOGS DESCRIPTION HEADER (width 22% / minWidth 220) - kept for backup */}
                                    {/* <TableCell align='center' sx={{ border: '1px solid',borderColor:theme.palette.divider, width: '22%', minWidth: 220 }}>DESCRIPTION</TableCell> */}
                                    {/* NEW CATALOGS DESCRIPTION HEADER - widened further per user request for more horizontal room */}
                                    <TableCell align='center' sx={{ border: '1px solid',borderColor:theme.palette.divider, width: '28%', minWidth: 280 }}>DESCRIPTION</TableCell>
                                    <TableCell align='center' sx={{ border: '1px solid',borderColor:theme.palette.divider }}>QTY ORDERED</TableCell>
                                    {canViewCosts && <TableCell align='center' sx={{ border: '1px solid',borderColor:theme.palette.divider }}>UNIT COST</TableCell>}
                                    <TableCell align='center' sx={{ border: '1px solid',borderColor:theme.palette.divider }}>QTY REC'D</TableCell>
                                    <TableCell align='center' sx={{ border: '1px solid',borderColor:theme.palette.divider }}>DELIVERED</TableCell>
                                    <TableCell align='center' sx={{ border: '1px solid',borderColor:theme.palette.divider }}>SERVICE NAME</TableCell>
                                    {canViewCosts && <TableCell align='center' sx={{ border: '1px solid',borderColor:theme.palette.divider }}>SERVICE COST</TableCell>}
                                    {canViewCosts && <TableCell align='center' sx={{ border: '1px solid',borderColor:theme.palette.divider }}>AMOUNT</TableCell>}
                                  </TableRow>
                                </TableHead>
                                  <TableBody>
                                    {orderPreviewData?.filter(item => item.meterial == 0).map((row,index) => {
                                      let { order_name,order_id, vendor_name, product_name,service_name, unit_cost, actual_qty, actual_total_cost,shipping_cost,service_cost } = row;
                                      const productDescription = invoice?.find(p => p?.material_inventory_id === row?.id)?.description || '-';
                                      return (
                                        <TableRow
                                          hover
                                          key={`catalog-${index}`}
                                          tabIndex={-1}
                                        >
                                          {/* OLD CATALOGS ROW CELLS - kept for backup */}
                                          {/* <TableCell align="center">{index + 1}</TableCell> */}
                                          {/* <TableCell align="center">{product_name || '-'}</TableCell> */}
                                          {/* <TableCell align="center">{service_name || '-'}</TableCell> */}
                                          {/* {canViewCosts && <TableCell align="center">${unit_cost || 0}</TableCell>} */}
                                          {/* <TableCell align="center">{actual_qty || 0}</TableCell> */}
                                          {/* <TableCell align="center">{shipping_cost || 0}</TableCell> */}
                                          {/* {canViewCosts && <TableCell align="center">{service_cost || 0}</TableCell>} */}
                                          {/* {canViewCosts && <TableCell align="center">${actual_total_cost || 0}</TableCell>} */}
                                          {/* NEW CATALOGS ROW CELLS - aligned with Create/Edit Receive Order */}
                                          <TableCell align="center">{product_name || '-'}</TableCell>
                                          <TableCell align="center">{productDescription}</TableCell>
                                          <TableCell align="center">{actual_qty || 0}</TableCell>
                                          {canViewCosts && <TableCell align="center">${unit_cost || 0}</TableCell>}
                                          <TableCell align="center">{orderPreviewData[0]?.order_status === 0 ? '-' : (actual_qty || 0)}</TableCell>
                                          <TableCell align="center">-</TableCell>
                                          <TableCell align="center">{service_name || '-'}</TableCell>
                                          {canViewCosts && <TableCell align="center">{service_cost || 0}</TableCell>}
                                          {canViewCosts && <TableCell align="center">${actual_total_cost || 0}</TableCell>}
                                        </TableRow>
                                      );
                                    })}
                                  </TableBody>
                                </Table>
                              </TableContainer>
                            </Scrollbar>
                          </>
                        )}

                        {/* Services Section */}
                        {orderServices && orderServices.length > 0 && (
                          <>
                            <Typography variant="h6" sx={{ mt: 2, mb: 1, fontWeight: 'bold' }}>
                              Services
                            </Typography>
                            <Scrollbar>
                              {/* OLD TABLE CONTAINER (native scrollbar) - kept for backup */}
                              {/* <TableContainer sx={{ maxWidth: '100%', border: '1px solid', borderColor: theme.palette.divider}}> */}
                              {/* NEW TABLE CONTAINER - theme-matched custom scrollbar */}
                              <TableContainer sx={{
                                maxWidth: '100%',
                                border: '1px solid',
                                borderColor: theme.palette.divider,
                                '&::-webkit-scrollbar': { height: 8, width: 8 },
                                '&::-webkit-scrollbar-track': { backgroundColor: theme.palette.background.paper },
                                '&::-webkit-scrollbar-thumb': { backgroundColor: theme.palette.divider, borderRadius: 4 },
                                '&::-webkit-scrollbar-thumb:hover': { backgroundColor: theme.palette.text.disabled },
                                scrollbarWidth: 'thin',
                                scrollbarColor: `${theme.palette.divider} ${theme.palette.background.paper}`
                              }}>
                                <Table>
                                <TableHead sx={{ width: '100%'}}>
                                  <TableRow>
                                    {/* OLD SERVICES HEADERS - kept for backup */}
                                    {/* <TableCell align='center' sx={{ border: '1px solid',borderColor:theme.palette.divider }}>#</TableCell> */}
                                    {/* <TableCell align='center' sx={{ border: '1px solid',borderColor:theme.palette.divider }}>Service Name</TableCell> */}
                                    {/* {canViewCosts && <TableCell align='center' sx={{ border: '1px solid',borderColor:theme.palette.divider }}>Price</TableCell>} */}
                                    {/* NEW SERVICES HEADERS - aligned with Create/Edit Receive Order */}
                                    <TableCell align='center' sx={{ border: '1px solid',borderColor:theme.palette.divider }}>#</TableCell>
                                    <TableCell align='center' sx={{ border: '1px solid',borderColor:theme.palette.divider }}>SERVICES</TableCell>
                                    {canViewCosts && <TableCell align='center' sx={{ border: '1px solid',borderColor:theme.palette.divider }}>TOTAL COST</TableCell>}
                                  </TableRow>
                                </TableHead>
                                  <TableBody>
                                    {orderServices.map((row,index) => {
                                      const serviceName = row.name || row.description || '';
                                      const servicePrice = parseFloat(row.price) || 0;
                                      return (
                                        <TableRow
                                          hover
                                          key={`receive-service-${index}`}
                                          tabIndex={-1}
                                        >
                                          <TableCell align="center">{index + 1}</TableCell>
                                          <TableCell align="center">{serviceName}</TableCell>
                                          {canViewCosts && <TableCell align="center">${servicePrice.toFixed(2)}</TableCell>}
                                        </TableRow>
                                      );
                                    })}
                                  </TableBody>
                                </Table>
                              </TableContainer>
                            </Scrollbar>
                          </>
                        )}

                       {canViewCosts && <Stack direction={{ xs: 'column', md: 'column' }}>
                        <Typography variant="subtitle2" sx={{mt:1}}>
                        Sub Total: <span style={{ color:theme.palette.primary.dark }}>{fUSPrice(orderPreviewData[0]?.sub_total)}</span>
                        </Typography>
                        <Typography variant="subtitle2" sx={{mt:1}}>
                          Tax: <span style={{ color:theme.palette.primary.dark }}>{orderPreviewData[0]?.tax}</span>
                        </Typography>
                        <Typography variant="subtitle2" sx={{mt:1}}>
                          Grand Total: <span style={{ color:theme.palette.primary.dark }}>{fUSPrice(orderPreviewData[0]?.grand_total)}</span>
                        </Typography>
                        </Stack>}
                        {/* </Card> */}
                        {orderPreviewData[0]?.order_status === 0 && <Box sx={{ mt: 3, display: 'flex', justifyContent: 'flex-end', gap:2 }}>
                          <Button variant='contained' type='submit' onClick={handleReceiveOrder}
                            disabled={loading2}> {loading2 ? <CircularProgress size={24} color="inherit" /> : 'Submit'}</Button>
                          {/* <LoadingButton variant='contained' type='submit' onClick={handleReceiveOrder}  loading={loading}>Submit</LoadingButton> */}
                          <Button variant='outlined' onClick={()=>{setReceivePreview(false); setSelectedPaymentMode(null); setValidSelection(true)}}>Cancel</Button>
                        </Box>}
                      </Stack> 

                    </Stack>
                  </Grid>
                </Grid>
              </>
            )}
          </Modal>
        )}

        {viewOrder && (
          <Modal
            open={viewOrder}
            handleClose={() => {
              setViewOrder(false);
            }}
            width="800px"
            modalTitle={`View Order - ${orderPreviewData[0]?.order_name?orderPreviewData[0]?.order_name :""}`}
          >
            {loading ? ( 
              <Stack alignItems='center' justifyContent='center'>
                <CircularProgress color="primary" variant="indeterminate" />
              </Stack>
             ) : (
              <>
                <Grid container sx={{ justifyContent: 'center' }} spacing={3}>
                  <Grid item xs={12} md={10}>
                    <Stack
                      sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        justifyContent: 'space-between',
                      }}
                      spacing={3}
                    >
                      <Stack
                        direction={{ xs: 'column', md: 'column' }} 
                        display="flex"
                        justifyContent="space-between"
                        spacing={3}
                      >
                        <Stack direction={{ xs: 'column', md: 'column' }} width={'100%'}>
                        <Typography variant="subtitle1">
                        Order ID : <span style={{ color:theme.palette.primary.dark, fontWeight:'bold' }}>{orderPreviewData[0]?.order_id}</span>
                        </Typography>
                        <Typography variant="subtitle1">
                          Order Name : <span style={{ color:theme.palette.primary.dark, fontWeight:'bold' }}>{orderPreviewData[0]?.order_name}</span>
                        </Typography>
                        <Typography variant="subtitle1">
                          Vendor : <span style={{ color:theme.palette.primary.dark, fontWeight:'bold' }}>{orderPreviewData[0]?.vendor_name}</span>
                        </Typography>
                        <Typography variant="subtitle1">
                          Qb Id : <span style={{ color:theme.palette.primary.dark, fontWeight:'bold' }}>{orderPreviewData[0]?.doc_number? `#${orderPreviewData[0]?.doc_number}` : ""}</span>
                        </Typography>
                        <Typography variant="subtitle1">
                          Date Expected : <span style={{ color:theme.palette.primary.dark, fontWeight:'bold' }}>{orderPreviewData[0]?.expected_date && orderPreviewData[0]?.expected_date > 0 ? formatDateOnly(orderPreviewData[0]?.expected_date) : "N/A"}</span>
                        </Typography>
                        <Typography variant="subtitle1">
                          Payment Mode : <span style={{ color:theme.palette.primary.dark, fontWeight:'bold' }}>{orderPreviewData[0]?.payment_mode && orderPreviewData[0]?.payment_mode > 0 ? (getPaymentMode(orderPreviewData[0]?.payment_mode).label || "N/A") : "N/A"}</span>
                        </Typography>
                        <Typography variant="subtitle1">
                          Order Type : <span style={{ color:theme.palette.primary.dark, fontWeight:'bold' }}>{getOrderTypeLabel(orderPreviewData[0]?.orderType)}</span>
                        </Typography>
                        <Typography variant="subtitle1">
                          Classification : <span style={{ color:theme.palette.primary.dark, fontWeight:'bold' }}>{orderPreviewData[0]?.project_type_name || "N/A"}</span>
                        </Typography>
                        <Grid item xs={12} sm={6} sx={{ mb: 5 }}>
                        <Label
                          variant={theme.palette.mode === 'light' ? 'ghost' : 'filled'}
                          color={getStatusColorAndLabel(orderPreviewData[0]?.order_status).color} >
                          {getStatusColorAndLabel(orderPreviewData[0]?.order_status).label}
                        </Label>
                        {/* {orderPreviewData[0]?.orderType !== 3 && ( */}
                        <Typography variant="subtitle2" sx={{ mt:2, color: `${(orderPreviewData[0]?.syncWithQuickbooks==1) ? 'green' : 'red'}` }}>
                        {(orderPreviewData[0]?.notSyncedMessage 
                          // ? orderPreviewData[0]?.notSyncedMessage.split('\n').map((line, index) => (
                          //   <span key={index} style={{ display: 'block' }}>{line}</span>
                          // )) 
                          ? <div dangerouslySetInnerHTML={{ __html: orderPreviewData[0]?.notSyncedMessage.replace(/\n/g, '<br />') }} />
                          : ((orderPreviewData[0]?.syncWithQuickbooks==1) ? 
                          'Successfully Synced With QuickBooks' : orderPreviewData[0]?.order_status !==0 ?
                          'Not Synced With QuickBooks.' : ""))}
                         
                        </Typography>
                        {/* )} */}
                        </Grid>
                        </Stack>

                        {/* Materials Section */}
                        {orderPreviewData?.filter(item => item.meterial == 1).length > 0 && (
                          <>
                            <Typography variant="h6" sx={{ mt: 2, mb: 1, fontWeight: 'bold' }}>
                              Materials
                            </Typography>
                            <Scrollbar>
                              {/* OLD TABLE CONTAINER (native scrollbar) - kept for backup */}
                              {/* <TableContainer sx={{ maxWidth: '100%', border: '1px solid', borderColor: theme.palette.divider}}> */}
                              {/* NEW TABLE CONTAINER - theme-matched custom scrollbar */}
                              <TableContainer sx={{
                                maxWidth: '100%',
                                border: '1px solid',
                                borderColor: theme.palette.divider,
                                '&::-webkit-scrollbar': { height: 8, width: 8 },
                                '&::-webkit-scrollbar-track': { backgroundColor: theme.palette.background.paper },
                                '&::-webkit-scrollbar-thumb': { backgroundColor: theme.palette.divider, borderRadius: 4 },
                                '&::-webkit-scrollbar-thumb:hover': { backgroundColor: theme.palette.text.disabled },
                                scrollbarWidth: 'thin',
                                scrollbarColor: `${theme.palette.divider} ${theme.palette.background.paper}`
                              }}>
                                <Table>
                                <TableHead sx={{ width: '100%'}}>
                                  <TableRow>
                                    {/* OLD VIEW MATERIALS HEADERS - kept for backup */}
                                    {/* <TableCell align='center' sx={{ border: '1px solid',borderColor:theme.palette.divider }}>#</TableCell> */}
                                    {/* <TableCell align='center' sx={{ border: '1px solid',borderColor:theme.palette.divider }}>Product Name</TableCell> */}
                                    {/* <TableCell align='center' sx={{ border: '1px solid',borderColor:theme.palette.divider }}>Service Name</TableCell> */}
                                    {/* <TableCell align='center' sx={{ border: '1px solid',borderColor:theme.palette.divider }}>Unit Cost</TableCell> */}
                                    {/* <TableCell align='center' sx={{ border: '1px solid',borderColor:theme.palette.divider }}>Quantity</TableCell> */}
                                    {/* <TableCell align='center' sx={{ border: '1px solid',borderColor:theme.palette.divider }}>Shipping Cost</TableCell> */}
                                    {/* <TableCell align='center' sx={{ border: '1px solid',borderColor:theme.palette.divider }}>Service Cost</TableCell> */}
                                    {/* <TableCell align='center' sx={{ border: '1px solid',borderColor:theme.palette.divider }}>Total</TableCell> */}
                                    {/* NEW VIEW MATERIALS HEADERS - aligned with Create/Edit Receive Order */}
                                    <TableCell align='center' sx={{ border: '1px solid',borderColor:theme.palette.divider }}>ITEM</TableCell>
                                    {/* OLD VIEW MATERIALS DESCRIPTION HEADER (default width) - kept for backup */}
                                    {/* <TableCell align='center' sx={{ border: '1px solid',borderColor:theme.palette.divider }}>DESCRIPTION</TableCell> */}
                                    {/* PREVIOUS VIEW MATERIALS DESCRIPTION HEADER (width 22% / minWidth 220) - kept for backup */}
                                    {/* <TableCell align='center' sx={{ border: '1px solid',borderColor:theme.palette.divider, width: '22%', minWidth: 220 }}>DESCRIPTION</TableCell> */}
                                    {/* NEW VIEW MATERIALS DESCRIPTION HEADER - widened further per user request for more horizontal room */}
                                    <TableCell align='center' sx={{ border: '1px solid',borderColor:theme.palette.divider, width: '28%', minWidth: 280 }}>DESCRIPTION</TableCell>
                                    <TableCell align='center' sx={{ border: '1px solid',borderColor:theme.palette.divider }}>QTY ORDERED</TableCell>
                                    <TableCell align='center' sx={{ border: '1px solid',borderColor:theme.palette.divider }}>UNIT COST</TableCell>
                                    <TableCell align='center' sx={{ border: '1px solid',borderColor:theme.palette.divider }}>QTY REC'D</TableCell>
                                    <TableCell align='center' sx={{ border: '1px solid',borderColor:theme.palette.divider }}>DELIVERED</TableCell>
                                    <TableCell align='center' sx={{ border: '1px solid',borderColor:theme.palette.divider }}>SERVICE NAME</TableCell>
                                    <TableCell align='center' sx={{ border: '1px solid',borderColor:theme.palette.divider }}>SERVICE COST</TableCell>
                                    <TableCell align='center' sx={{ border: '1px solid',borderColor:theme.palette.divider }}>AMOUNT</TableCell>
                                  </TableRow>
                                </TableHead>
                                  <TableBody>
                                    {orderPreviewData?.filter(item => item.meterial == 1).map((row,index) => {
                                      let { order_name,order_id, vendor_name, product_name,service_name, unit_cost, actual_qty,actual_unit_qty, actual_total_cost,service_cost,shipping_cost,convertion_qty,convertion_unit } = row;
                                       const total_qty = actual_unit_qty * convertion_qty;
                                      const unitName = convertion_unit? UNITS.find(item => item.id == convertion_unit)?.name:'Unit';
                                      const quantity = convertion_unit==4 ?`${actual_unit_qty || 0} ${unitName}` : `${actual_unit_qty || 0}(${total_qty} ${unitName})`;
                                      const productDescription = invoice?.find(p => p?.material_inventory_id === row?.id)?.description || '-';
                                      
                                      return (
                                        <TableRow
                                          hover
                                          key={`view-material-${index}`}
                                          tabIndex={-1}
                                        >
                                          {/* OLD VIEW MATERIALS ROW CELLS - kept for backup */}
                                          {/* <TableCell align='center' sx={{ border: '0.5px solid',borderColor:theme.palette.divider }}> {index+1} </TableCell> */}
                                          {/* <TableCell align="center" sx={{ border: '0.5px solid',borderColor:theme.palette.divider }}> {product_name} </TableCell> */}
                                          {/* <TableCell align="center" sx={{ border: '0.5px solid',borderColor:theme.palette.divider }}> {service_name || ''} </TableCell> */}
                                          {/* <TableCell align="center" sx={{ border: '0.5px solid',borderColor:theme.palette.divider }}> ${unit_cost} </TableCell> */}
                                          {/* <TableCell align="center" sx={{ border: '0.5px solid',borderColor:theme.palette.divider }}> {quantity} </TableCell> */}
                                          {/* <TableCell align="center" sx={{ border: '0.5px solid',borderColor:theme.palette.divider }}> {actual_qty} </TableCell> */}
                                          {/* <TableCell align="center" sx={{ border: '0.5px solid',borderColor:theme.palette.divider }}> {shipping_cost} </TableCell> */}
                                          {/* <TableCell align="center" sx={{ border: '0.5px solid',borderColor:theme.palette.divider }}> {service_cost} </TableCell> */}
                                          {/* <TableCell align="center" sx={{ border: '0.5px solid',borderColor:theme.palette.divider }}> ${actual_total_cost} </TableCell> */}
                                          {/* NEW VIEW MATERIALS ROW CELLS - aligned with Create/Edit Receive Order */}
                                          <TableCell align="center" sx={{ border: '0.5px solid',borderColor:theme.palette.divider }}> {product_name || '-'} </TableCell>
                                          <TableCell align="center" sx={{ border: '0.5px solid',borderColor:theme.palette.divider }}> {productDescription} </TableCell>
                                          <TableCell align="center" sx={{ border: '0.5px solid',borderColor:theme.palette.divider }}> {quantity} </TableCell>
                                          <TableCell align="center" sx={{ border: '0.5px solid',borderColor:theme.palette.divider }}> ${unit_cost} </TableCell>
                                          <TableCell align="center" sx={{ border: '0.5px solid',borderColor:theme.palette.divider }}> {orderPreviewData[0]?.order_status === 0 ? '-' : quantity} </TableCell>
                                          <TableCell align="center" sx={{ border: '0.5px solid',borderColor:theme.palette.divider }}> - </TableCell>
                                          <TableCell align="center" sx={{ border: '0.5px solid',borderColor:theme.palette.divider }}> {service_name || ''} </TableCell>
                                          <TableCell align="center" sx={{ border: '0.5px solid',borderColor:theme.palette.divider }}> {service_cost} </TableCell>
                                          <TableCell align="center" sx={{ border: '0.5px solid',borderColor:theme.palette.divider }}> ${actual_total_cost} </TableCell>
                                        </TableRow>
                                      );
                                    })}
                                  </TableBody>
                                </Table>
                              </TableContainer>
                            </Scrollbar>
                          </>
                        )}

                        {/* Catalogs Section */}
                        {orderPreviewData?.filter(item => item.meterial == 0).length > 0 && (
                          <>
                            <Typography variant="h6" sx={{ mt: 2, mb: 1, fontWeight: 'bold' }}>
                              Catalogs
                            </Typography>
                            <Scrollbar>
                              {/* OLD TABLE CONTAINER (native scrollbar) - kept for backup */}
                              {/* <TableContainer sx={{ maxWidth: '100%', border: '1px solid', borderColor: theme.palette.divider}}> */}
                              {/* NEW TABLE CONTAINER - theme-matched custom scrollbar */}
                              <TableContainer sx={{
                                maxWidth: '100%',
                                border: '1px solid',
                                borderColor: theme.palette.divider,
                                '&::-webkit-scrollbar': { height: 8, width: 8 },
                                '&::-webkit-scrollbar-track': { backgroundColor: theme.palette.background.paper },
                                '&::-webkit-scrollbar-thumb': { backgroundColor: theme.palette.divider, borderRadius: 4 },
                                '&::-webkit-scrollbar-thumb:hover': { backgroundColor: theme.palette.text.disabled },
                                scrollbarWidth: 'thin',
                                scrollbarColor: `${theme.palette.divider} ${theme.palette.background.paper}`
                              }}>
                                <Table>
                                <TableHead sx={{ width: '100%'}}>
                                  <TableRow>
                                    {/* OLD VIEW CATALOGS HEADERS - kept for backup */}
                                    {/* <TableCell align='center' sx={{ border: '1px solid',borderColor:theme.palette.divider }}>#</TableCell> */}
                                    {/* <TableCell align='center' sx={{ border: '1px solid',borderColor:theme.palette.divider }}>Product Name</TableCell> */}
                                    {/* <TableCell align='center' sx={{ border: '1px solid',borderColor:theme.palette.divider }}>Service Name</TableCell> */}
                                    {/* <TableCell align='center' sx={{ border: '1px solid',borderColor:theme.palette.divider }}>Unit Cost</TableCell> */}
                                    {/* <TableCell align='center' sx={{ border: '1px solid',borderColor:theme.palette.divider }}>Quantity</TableCell> */}
                                    {/* <TableCell align='center' sx={{ border: '1px solid',borderColor:theme.palette.divider }}>Shipping Cost</TableCell> */}
                                    {/* <TableCell align='center' sx={{ border: '1px solid',borderColor:theme.palette.divider }}>Service Cost</TableCell> */}
                                    {/* <TableCell align='center' sx={{ border: '1px solid',borderColor:theme.palette.divider }}>Total</TableCell> */}
                                    {/* NEW VIEW CATALOGS HEADERS - aligned with Create/Edit Receive Order */}
                                    <TableCell align='center' sx={{ border: '1px solid',borderColor:theme.palette.divider }}>ITEM</TableCell>
                                    {/* OLD VIEW CATALOGS DESCRIPTION HEADER (default width) - kept for backup */}
                                    {/* <TableCell align='center' sx={{ border: '1px solid',borderColor:theme.palette.divider }}>DESCRIPTION</TableCell> */}
                                    {/* PREVIOUS VIEW CATALOGS DESCRIPTION HEADER (width 22% / minWidth 220) - kept for backup */}
                                    {/* <TableCell align='center' sx={{ border: '1px solid',borderColor:theme.palette.divider, width: '22%', minWidth: 220 }}>DESCRIPTION</TableCell> */}
                                    {/* NEW VIEW CATALOGS DESCRIPTION HEADER - widened further per user request for more horizontal room */}
                                    <TableCell align='center' sx={{ border: '1px solid',borderColor:theme.palette.divider, width: '28%', minWidth: 280 }}>DESCRIPTION</TableCell>
                                    <TableCell align='center' sx={{ border: '1px solid',borderColor:theme.palette.divider }}>QTY ORDERED</TableCell>
                                    <TableCell align='center' sx={{ border: '1px solid',borderColor:theme.palette.divider }}>UNIT COST</TableCell>
                                    <TableCell align='center' sx={{ border: '1px solid',borderColor:theme.palette.divider }}>QTY REC'D</TableCell>
                                    <TableCell align='center' sx={{ border: '1px solid',borderColor:theme.palette.divider }}>DELIVERED</TableCell>
                                    <TableCell align='center' sx={{ border: '1px solid',borderColor:theme.palette.divider }}>SERVICE NAME</TableCell>
                                    <TableCell align='center' sx={{ border: '1px solid',borderColor:theme.palette.divider }}>SERVICE COST</TableCell>
                                    <TableCell align='center' sx={{ border: '1px solid',borderColor:theme.palette.divider }}>AMOUNT</TableCell>
                                  </TableRow>
                                </TableHead>
                                  <TableBody>
                                    {orderPreviewData?.filter(item => item.meterial == 0).map((row,index) => {
                                      let { order_name,order_id, vendor_name, product_name,service_name, unit_cost, actual_qty, actual_total_cost,service_cost,shipping_cost } = row;
                                      const productDescription = invoice?.find(p => p?.material_inventory_id === row?.id)?.description || '-';
                                      return (
                                        <TableRow
                                          hover
                                          key={`view-catalog-${index}`}
                                          tabIndex={-1}
                                        >
                                          {/* OLD VIEW CATALOGS ROW CELLS - kept for backup */}
                                          {/* <TableCell align='center' sx={{ border: '0.5px solid',borderColor:theme.palette.divider }}> {index+1} </TableCell> */}
                                          {/* <TableCell align="center" sx={{ border: '0.5px solid',borderColor:theme.palette.divider }}> {product_name} </TableCell> */}
                                          {/* <TableCell align="center" sx={{ border: '0.5px solid',borderColor:theme.palette.divider }}> {service_name || ''} </TableCell> */}
                                          {/* <TableCell align="center" sx={{ border: '0.5px solid',borderColor:theme.palette.divider }}> ${unit_cost} </TableCell> */}
                                          {/* <TableCell align="center" sx={{ border: '0.5px solid',borderColor:theme.palette.divider }}> {actual_qty} </TableCell> */}
                                          {/* <TableCell align="center" sx={{ border: '0.5px solid',borderColor:theme.palette.divider }}> {shipping_cost} </TableCell> */}
                                          {/* <TableCell align="center" sx={{ border: '0.5px solid',borderColor:theme.palette.divider }}> {service_cost} </TableCell> */}
                                          {/* <TableCell align="center" sx={{ border: '0.5px solid',borderColor:theme.palette.divider }}> ${actual_total_cost} </TableCell> */}
                                          {/* NEW VIEW CATALOGS ROW CELLS - aligned with Create/Edit Receive Order */}
                                          <TableCell align="center" sx={{ border: '0.5px solid',borderColor:theme.palette.divider }}> {product_name || '-'} </TableCell>
                                          <TableCell align="center" sx={{ border: '0.5px solid',borderColor:theme.palette.divider }}> {productDescription} </TableCell>
                                          <TableCell align="center" sx={{ border: '0.5px solid',borderColor:theme.palette.divider }}> {actual_qty} </TableCell>
                                          <TableCell align="center" sx={{ border: '0.5px solid',borderColor:theme.palette.divider }}> ${unit_cost} </TableCell>
                                          <TableCell align="center" sx={{ border: '0.5px solid',borderColor:theme.palette.divider }}> {orderPreviewData[0]?.order_status === 0 ? '-' : actual_qty} </TableCell>
                                          <TableCell align="center" sx={{ border: '0.5px solid',borderColor:theme.palette.divider }}> - </TableCell>
                                          <TableCell align="center" sx={{ border: '0.5px solid',borderColor:theme.palette.divider }}> {service_name || ''} </TableCell>
                                          <TableCell align="center" sx={{ border: '0.5px solid',borderColor:theme.palette.divider }}> {service_cost} </TableCell>
                                          <TableCell align="center" sx={{ border: '0.5px solid',borderColor:theme.palette.divider }}> ${actual_total_cost} </TableCell>
                                        </TableRow>
                                      );
                                    })}
                                  </TableBody>
                                </Table>
                              </TableContainer>
                            </Scrollbar>
                          </>
                        )}

                        {/* Services Section */}
                        {orderServices && orderServices.length > 0 && (
                          <>
                            <Typography variant="h6" sx={{ mt: 2, mb: 1, fontWeight: 'bold' }}>
                              Services
                            </Typography>
                            <Scrollbar>
                              {/* OLD TABLE CONTAINER (native scrollbar) - kept for backup */}
                              {/* <TableContainer sx={{ maxWidth: '100%', border: '1px solid', borderColor: theme.palette.divider}}> */}
                              {/* NEW TABLE CONTAINER - theme-matched custom scrollbar */}
                              <TableContainer sx={{
                                maxWidth: '100%',
                                border: '1px solid',
                                borderColor: theme.palette.divider,
                                '&::-webkit-scrollbar': { height: 8, width: 8 },
                                '&::-webkit-scrollbar-track': { backgroundColor: theme.palette.background.paper },
                                '&::-webkit-scrollbar-thumb': { backgroundColor: theme.palette.divider, borderRadius: 4 },
                                '&::-webkit-scrollbar-thumb:hover': { backgroundColor: theme.palette.text.disabled },
                                scrollbarWidth: 'thin',
                                scrollbarColor: `${theme.palette.divider} ${theme.palette.background.paper}`
                              }}>
                                <Table>
                                <TableHead sx={{ width: '100%'}}>
                                  <TableRow>
                                    {/* OLD VIEW SERVICES HEADERS - kept for backup */}
                                    {/* <TableCell align='center' sx={{ border: '1px solid',borderColor:theme.palette.divider }}>#</TableCell> */}
                                    {/* <TableCell align='center' sx={{ border: '1px solid',borderColor:theme.palette.divider }}>Service Name</TableCell> */}
                                    {/* <TableCell align='center' sx={{ border: '1px solid',borderColor:theme.palette.divider }}>Price</TableCell> */}
                                    {/* NEW VIEW SERVICES HEADERS - aligned with Create/Edit Receive Order */}
                                    <TableCell align='center' sx={{ border: '1px solid',borderColor:theme.palette.divider }}>#</TableCell>
                                    <TableCell align='center' sx={{ border: '1px solid',borderColor:theme.palette.divider }}>SERVICES</TableCell>
                                    <TableCell align='center' sx={{ border: '1px solid',borderColor:theme.palette.divider }}>TOTAL COST</TableCell>
                                  </TableRow>
                                </TableHead>
                                  <TableBody>
                                    {orderServices.map((row,index) => {
                                      const serviceName = row.name || row.description || '';
                                      const servicePrice = parseFloat(row.price) || 0;
                                      return (
                                        <TableRow
                                          hover
                                          key={`view-service-${index}`}
                                          tabIndex={-1}
                                        >
                                          <TableCell align='center' sx={{ border: '0.5px solid',borderColor:theme.palette.divider }}> {index+1} </TableCell>
                                          <TableCell align="center" sx={{ border: '0.5px solid',borderColor:theme.palette.divider }}> {serviceName} </TableCell>
                                          <TableCell align="center" sx={{ border: '0.5px solid',borderColor:theme.palette.divider }}> ${servicePrice.toFixed(2)} </TableCell>
                                        </TableRow>
                                      );
                                    })}
                                  </TableBody>
                                </Table>
                              </TableContainer>
                            </Scrollbar>
                          </>
                        )}

                        <Stack direction={{ xs: 'column', md: 'column' }}>
                        <Typography variant="subtitle2" sx={{mt:1}}>
                        Sub Total: <span style={{ color:theme.palette.primary.dark }}>{fUSPrice(orderPreviewData[0]?.sub_total)}</span>
                        </Typography>
                        <Typography variant="subtitle2" sx={{mt:1}}>
                          Tax: <span style={{ color:theme.palette.primary.dark }}>{orderPreviewData[0]?.tax}</span>
                        </Typography>
                        <Typography variant="subtitle2" sx={{mt:1}}>
                          Grand Total: <span style={{ color:theme.palette.primary.dark }}>{fUSPrice(orderPreviewData[0]?.grand_total)}</span>
                        </Typography>
                        </Stack>
                        {/* </Card> */}
                      </Stack> 

                    </Stack>
                  </Grid>
                </Grid>
              </>
            )}
          </Modal>
        )}

        {invoicePreview && (
          <Modal
            open={invoicePreview}
            handleClose={() => {
              setInvoicePreview(false);
            }}
            modalTitle={`Purchase Order - ${orderPreviewData[0]?.order_name}`}
          >
          {(!orderPreviewData && !invoice) ?
            <Stack alignItems="center" justifyContent="center" style={{ height: '100%',width:'100%' }}>
              <CircularProgress color="primary" variant="indeterminate" />
            </Stack> 
            :
            <>
              <Stack direction={{ xs: 'column', sm: 'row', md: 'column' }}
                spacing={{ xs: 3, sm: 2 }}>
                {/* OLD PRINT/EMAIL ROW (no marginBottom) - kept for backup */}
                {/* <Stack direction="row" justifyContent={'flex-end'} alignItems="center" spacing={1}> */}
                {/* NEW PRINT/EMAIL ROW - added marginBottom to separate from section below */}
                <Stack direction="row" justifyContent={'flex-end'} alignItems="center" spacing={1} sx={{ mb: 3 }}>
                  <ReactToPrint
                    trigger={() => (<Button> <Print />Print</Button>)}
                    content={() => componentRef.current}
                    // copyStyles={false}
    pageStyle={`
      @page {
        size: A3;
        margin: 12mm;
      }
      body {
        font-family: 'Public Sans', sans-serif;
        font-size: 12pt;
      }
      table {
        width: 100%;
        border-collapse: collapse;
      }
                        #right {
                          text-align: right;
                          margin-top: -200px; 
                        }
                        #total {
                          text-align: right;
                          display:flex;
                          justify-content: flex-end;
                        }
                        #subtotal {
                          text-align: left;
                          
                        }
                        #discount {
                          text-align: left;
                          word-wrap: break-word;
                          margin-right: 100px;
                      }
                      
                        #totalmain {
                          text-align: left;
                          
                        }
                        #subtotal1 {
                          text-align: left;
                          
                        }
                        #discount1 {
                          text-align: left;
                          word-wrap: break-word;
                          margin-right: 30px;
                      }
                      
                        #totalmain1 {
                          text-align: left;
                          
                        }
                        #total1 {
                          text-align: right;
                          display:flex;
                          justify-content: flex-end;
                          margin-top: -220px; 
                          
                        }
                        #order{
                          margin-bottom:-20px
                        }
                        #title{
                          margin-bottom:-20px
                        }
                        #orderID {
                          margin-bottom:-20px
                        }
                        #to {
                          margin-bottom:-20px
                        }
                        
                      }
                    `}
                  />
                  <Button onClick={() => setOpenEmailModal(true)}> <EmailOutlined /></Button>
                  <div style={{ display: "none" }}>
                    <PurchaseOrderInvoicePage
                      invoiceDate={invoiceDate}
                      details={orderPreviewData[0]}
                      invoice={invoice}
                      orderServices={orderServices}
                      data={data}
                      hasViewCostPermission={canViewCosts}
                      ref={componentRef}
                    />          
                  </div>
                </Stack>
              </Stack>
              <Grid container spacing={3} >

                {/* OLD TOP SECTION (LEFT: LOGO + COMPANY INFO) - kept for backup */}
                {/* <Grid item xs={12} sm={6} sx={{ mb: 5 }}>
                  <Grid item xs={12} sm={6} sx={{ mb: 5 }}>
                <Box component="img" alt="logo" src={COMPANY_LOGO} sx={{ height: 98 }} />
              </Grid>
                  <Typography variant="body2">{COMPANY_NAME}</Typography>
                  <Typography variant="body2" sx={{ textTransform: 'uppercase' }}>{data?.company_website}</Typography>
                  <Typography variant="body2">
                    {data?.address}, {data?.city}, {data?.state}, {data?.zipcode}
                  </Typography>
                  <Typography variant="body2">Telephone: +15208362947</Typography>
                  <Box sx={{ display: 'flex', flexDirection: 'row', gap: 1 }}>
                    <Typography variant="body2" sx={{ textTransform: 'uppercase', }}>Telephone: {(data?.phone_country_code || data?.phone) ? `+${data?.phone_country_code}${data?.phone}` : '951-682-9660'}</Typography>
                    <Typography variant="body2" sx={{ textTransform: 'uppercase' }}>|</Typography>
                    <Typography variant="body2" sx={{ textTransform: 'uppercase' }}>{data?.company_fax_number ? `Fax: ${data?.company_fax_number}` : ''}</Typography>
                  </Box>
                  <Typography variant="body2" sx={{ textTransform: 'uppercase' }}>{data?.company_mail}</Typography>
                </Grid> */}
                {/* OLD TOP SECTION (RIGHT: ORDER DATE / STATUS / ORDER NAME / ID / VENDOR / QB) - kept for backup */}
                {/* <Grid item xs={12} sm={6} sx={{ mb: 5 }}>

                  <Typography variant="body2" sx={{marginBottom: '5px' }}>
                    Order date: {invoiceDate}
                  </Typography>
                  <Stack sx={{display:'flex',flexDirection:'row'}}>
                  <Typography variant="body2">Order status:</Typography>
                  <Label
                    variant={theme.palette.mode === 'light' ? 'ghost' : 'filled'}
                    color={getStatusColorAndLabel(orderPreviewData[0]?.order_status).color} >
                    {getStatusColorAndLabel(orderPreviewData[0]?.order_status).label}
                  </Label>
                  </Stack>
                  <Typography variant="body2" sx={{marginTop: '5px' }}>Order Name : {orderPreviewData[0]?.order_name}</Typography>
                  <Typography variant="body2" sx={{marginTop: '5px' }}>Order ID : {orderPreviewData[0]?.order_id}</Typography>
                  <Typography variant="body2" sx={{marginTop: '5px' }}>Vendor Name : {orderPreviewData[0]?.vendor_name}</Typography>
                  <Typography variant="body2" sx={{marginTop: '5px' }}>{orderPreviewData[0]?.vendor_phone && 'Phone: +'+orderPreviewData[0]?.vendor_phone}</Typography>
                  <Typography variant="body2" sx={{marginTop: '5px' }}>
                    Qb Id : {orderPreviewData[0]?.doc_number? `#${orderPreviewData[0]?.doc_number}` : ""}
                        </Typography>
                </Grid> */}

                {/* NEW TOP SECTION - mirrors PurchaseOrderInvoicePage.js (FUSION SIGN & DESIGN block on left, PURCHASE ORDER heading + DATE/P.O. NO. table on right) */}
                <Grid item xs={12} sm={6} sx={{ mb: 5 }}>
                  <Stack direction="column" spacing={0.5}>
                    {/* PREVIOUS PURCHASE ORDER COMPANY NAME (static COMPANY_NAME constant -> always rendered the Defaultvalues fallback like "SIGNWISE SOLUTIONS" because the constant import never reads the active workspace's company_name from localStorage) - kept for backup */}
                    {/* <Typography variant="h6" sx={{ fontWeight: 700, textTransform: 'uppercase' }}>{COMPANY_NAME}</Typography> */}
                    {/* NEW PURCHASE ORDER COMPANY NAME - uses useCompanyProfile().COMPANY_NAME (aliased to companyProfileName) so it shows the active workspace name, matching PurchaseOrderInvoicePage.js (line 29-31, 52). */}
                    <Typography variant="h6" sx={{ fontWeight: 700, textTransform: 'uppercase' }}>{companyProfileName}</Typography>
                    <Typography variant="body2" sx={{ textTransform: 'uppercase' }}>{data?.address}</Typography>
                    <Typography variant="body2" sx={{ textTransform: 'uppercase' }}>{data?.city}, {data?.state} {data?.zipcode}</Typography>
                    <Typography variant="body2" sx={{ textTransform: 'uppercase' }}>
                      Phone # {(data?.phone_country_code || data?.phone) ? `${data?.phone_country_code ? `+${data?.phone_country_code} ` : ''}${data?.phone}` : '951-682-9660'}
                    </Typography>
                    <Typography variant="body2" sx={{ textTransform: 'uppercase' }}>Fax # {data?.company_fax_number || ''}</Typography>
                  </Stack>
                </Grid>
                <Grid item xs={12} sm={6} sx={{ mb: 5, display: 'flex', flexDirection: 'column', alignItems: 'flex-end' }}>
                  <Typography
                    variant="h4"
                    sx={{
                      textTransform: 'uppercase',
                      textAlign: 'center',
                      fontWeight: 'bold',
                      mb: 1,
                      letterSpacing: '0.5px',
                      whiteSpace: 'nowrap',
                      width: '100%'
                    }}
                  >
                    Purchase Order
                  </Typography>
                  <Box sx={{ width: '58%', ml: 'auto' }}>
                    {/* OLD DATE/P.O. NO. TABLE (no cell borders) - kept for backup */}
                    {/* <Table size="small" sx={{ tableLayout: 'fixed' }}> */}
                    {/* PREVIOUS DATE/P.O. NO. TABLE (borders but tight cell padding caused date text to touch the border) - kept for backup */}
                    {/* <Table size="small" sx={{ tableLayout: 'fixed', '& .MuiTableCell-root': { border: '1px solid', borderColor: theme.palette.divider } }}> */}
                    {/* PREVIOUS DATE/P.O. NO. TABLE (borders + symmetric `padding: 8px 10px` shorthand, but the MUI theme's MuiTableCell overrides for :first-of-type / :last-of-type set paddingLeft / paddingRight to theme.spacing(3) = 24px which beat the shorthand on specificity, so the DATE/P.O. NO. text shifted off-center toward the outer borders) - kept for backup */}
                    {/* <Table size="small" sx={{ tableLayout: 'fixed', '& .MuiTableCell-root': { border: '1px solid', borderColor: theme.palette.divider, padding: '8px 10px' } }}> */}
                    {/* NEW DATE/P.O. NO. TABLE - explicitly override :first-of-type / :last-of-type paddingLeft / paddingRight so first and last cells get symmetric horizontal padding (10px each side) and the date text stays centered without hitting the borders. */}
                    <Table
                      size="small"
                      sx={{
                        tableLayout: 'fixed',
                        '& .MuiTableCell-root': {
                          border: '1px solid',
                          borderColor: theme.palette.divider,
                          padding: '8px 10px',
                          paddingLeft: '10px',
                          paddingRight: '10px'
                        },
                        '& .MuiTableCell-root:first-of-type': {
                          paddingLeft: '10px',
                          paddingRight: '10px'
                        },
                        '& .MuiTableCell-root:last-of-type': {
                          paddingLeft: '10px',
                          paddingRight: '10px'
                        }
                      }}
                    >
                      <TableHead>
                        <TableRow>
                          <TableCell align="center" sx={{ fontWeight: 'bold', textTransform: 'uppercase', width: '50%' }}>
                            Date
                          </TableCell>
                          <TableCell align="center" sx={{ fontWeight: 'bold', textTransform: 'uppercase', width: '50%' }}>
                            P.O. No.
                          </TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        <TableRow>
                          <TableCell align="center" sx={{ textTransform: 'uppercase' }}>
                            {invoiceDate}
                          </TableCell>
                          <TableCell align="center" sx={{ textTransform: 'uppercase' }}>
                            #{orderPreviewData[0]?.doc_number || orderPreviewData[0]?.order_id || ''}
                          </TableCell>
                        </TableRow>
                      </TableBody>
                    </Table>
                  </Box>
                </Grid>
              </Grid>

              {/* NEW PURCHASE ORDER UPPER SECTIONS - mirrors PurchaseOrderInvoicePage.js (VENDOR / SHIP TO + ORDER PLACED WITH row) using MUI Table */}
              <Grid container spacing={2} sx={{ mb: 2 }}>
                {/* VENDOR block */}
                <Grid item xs={12} sm={6}>
                  <TableContainer>
                    {/* OLD VENDOR TABLE (no cell borders) - kept for backup */}
                    {/* <Table size="small"> */}
                    {/* NEW VENDOR TABLE - borders on all cells */}
                    <Table size="small" sx={{ '& .MuiTableCell-root': { border: '1px solid', borderColor: theme.palette.divider } }}>
                      <TableHead>
                        <TableRow>
                          <TableCell sx={{ fontWeight: 'bold', textTransform: 'uppercase' }}>
                            Vendor
                          </TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        <TableRow>
                          <TableCell sx={{ verticalAlign: 'top', textTransform: 'uppercase', height: 140 }}>
                            {orderPreviewData[0]?.vendor_name || ''}
                            <br />
                            {orderPreviewData[0]?.vendor_address || ''}
                            <br /><br />
                            Phone # {orderPreviewData[0]?.vendor_phone || ''}
                            <br />
                            Fax # {orderPreviewData[0]?.vendor_fax || ''}
                          </TableCell>
                        </TableRow>
                      </TableBody>
                    </Table>
                  </TableContainer>
                </Grid>

                {/* SHIP TO block */}
                <Grid item xs={12} sm={6}>
                  <TableContainer>
                    {/* OLD SHIP TO TABLE (no cell borders) - kept for backup */}
                    {/* <Table size="small"> */}
                    {/* NEW SHIP TO TABLE - borders on all cells */}
                    <Table size="small" sx={{ '& .MuiTableCell-root': { border: '1px solid', borderColor: theme.palette.divider } }}>
                      <TableHead>
                        <TableRow>
                          <TableCell sx={{ fontWeight: 'bold', textTransform: 'uppercase' }}>
                            Ship To
                          </TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        <TableRow>
                          <TableCell sx={{ verticalAlign: 'top', textTransform: 'uppercase', height: 140 }}>
                            {COMPANY_NAME}
                            <br />
                            {data?.address}
                            <br />
                            {data?.city}, {data?.state}, {data?.zipcode}
                          </TableCell>
                        </TableRow>
                      </TableBody>
                    </Table>
                  </TableContainer>
                </Grid>
              </Grid>

              {/* ORDER PLACED WITH / PROJECT / TERMS / DATE REQ'D / DATE PROMISED / SHIP VIA row */}
              <TableContainer sx={{ mb: 2 }}>
                {/* OLD ORDER PLACED WITH TABLE (no cell borders) - kept for backup */}
                {/* <Table size="small" sx={{ tableLayout: 'fixed' }}> */}
                {/* PREVIOUS ORDER PLACED WITH TABLE (borders but tight cell padding caused "Date Promised" to touch the border) - kept for backup */}
                {/* <Table size="small" sx={{ tableLayout: 'fixed', '& .MuiTableCell-root': { border: '1px solid', borderColor: theme.palette.divider } }}> */}
                {/* NEW ORDER PLACED WITH TABLE - borders + extra cell padding so wrapped header text (e.g. DATE PROMISED) does not touch the border */}
                <Table size="small" sx={{ tableLayout: 'fixed', '& .MuiTableCell-root': { border: '1px solid', borderColor: theme.palette.divider, padding: '8px 10px' } }}>
                  <TableHead>
                    <TableRow>
                      <TableCell align="center" sx={{ fontWeight: 'bold', textTransform: 'uppercase', width: '19%' }}>
                        Order Placed With
                      </TableCell>
                      <TableCell align="center" sx={{ fontWeight: 'bold', textTransform: 'uppercase', width: '23%' }}>
                        Project / Sales Order #
                      </TableCell>
                      <TableCell align="center" sx={{ fontWeight: 'bold', textTransform: 'uppercase', width: '15%' }}>
                        Terms
                      </TableCell>
                      <TableCell align="center" sx={{ fontWeight: 'bold', textTransform: 'uppercase', width: '12.5%' }}>
                        Date Req'd
                      </TableCell>
                      <TableCell
                        align="center"
                        sx={{
                          fontWeight: 'bold',
                          textTransform: 'uppercase',
                          width: '12.5%',
                          padding: '8px 28px 8px 10px'
                        }}
                      >
                        Date Promised
                      </TableCell>
                      <TableCell align="center" sx={{ fontWeight: 'bold', textTransform: 'uppercase', width: '18%' }}>
                        Ship Via
                      </TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    <TableRow>
                      <TableCell align="center" sx={{ textTransform: 'uppercase', wordBreak: 'break-word' }}>
                        {orderPreviewData[0]?.sales_order_doc_number || ''}
                      </TableCell>
                      <TableCell align="center" sx={{ textTransform: 'uppercase', wordBreak: 'break-word' }}>
                        {orderPreviewData[0]?.sales_order_name || ''}
                      </TableCell>
                      <TableCell align="center" sx={{ textTransform: 'uppercase', wordBreak: 'break-word' }}>
                        {orderPreviewData[0]?.customer_billing_type && orderPreviewData[0]?.customer_billing_type_value != null
                          ? `${orderPreviewData[0].customer_billing_type} ( ${orderPreviewData[0].customer_billing_type_value} % )`
                          : ''}
                      </TableCell>
                      {/* PREVIOUS DATE REQ'D VALUE CELL (wordBreak allowed date to wrap) - kept for backup */}
                      {/* <TableCell align="center" sx={{ textTransform: 'uppercase', wordBreak: 'break-word' }}> */}
                      {/* NEW DATE REQ'D VALUE CELL - keep date on one line */}
                      <TableCell align="center" sx={{ textTransform: 'uppercase', whiteSpace: 'nowrap' }}>
                        {(orderPreviewData[0]?.sales_order_participation_ends || orderPreviewData[0]?.sales_order_installation_end_date)
                          ? formatDateOnly(orderPreviewData[0]?.sales_order_participation_ends || orderPreviewData[0]?.sales_order_installation_end_date)
                          : ''}
                      </TableCell>
                      {/* PREVIOUS DATE PROMISED VALUE CELL (wordBreak allowed date to wrap) - kept for backup */}
                      {/* <TableCell align="center" sx={{ textTransform: 'uppercase', wordBreak: 'break-word' }}> */}
                      {/* NEW DATE PROMISED VALUE CELL - keep date on one line */}
                      <TableCell
                        align="center"
                        sx={{
                          textTransform: 'uppercase',
                          whiteSpace: 'nowrap',
                          padding: '8px 28px 8px 10px'
                        }}
                      >
                        {orderPreviewData[0]?.expected_date ? formatDateOnly(orderPreviewData[0]?.expected_date) : ''}
                      </TableCell>
                      <TableCell align="center" sx={{ textTransform: 'uppercase', wordBreak: 'break-word' }}>
                        {orderPreviewData[0]?.ship_via || ''}
                      </TableCell>
                    </TableRow>
                  </TableBody>
                </Table>
              </TableContainer>

              <Grid container spacing={2}>
                {/* Materials Section */}
                {invoice?.filter(item => item.meterial == 1).length > 0 && (
                  <Grid item xs={12}>
                    <Typography variant="h6" sx={{ mt: 2, mb: 1, fontWeight: 'bold' }}>
                      Materials
                    </Typography>
                    <Scrollbar>
                      {/* OLD INVOICE MATERIALS TABLE CONTAINER (native scrollbar) - kept for backup */}
                      {/* <TableContainer sx={{ minWidth: '100%' }}> */}
                      {/* NEW INVOICE MATERIALS TABLE CONTAINER - theme-matched custom scrollbar */}
                      <TableContainer sx={{
                        minWidth: '100%',
                        '&::-webkit-scrollbar': { height: 8, width: 8 },
                        '&::-webkit-scrollbar-track': { backgroundColor: theme.palette.background.paper },
                        '&::-webkit-scrollbar-thumb': { backgroundColor: theme.palette.divider, borderRadius: 4 },
                        '&::-webkit-scrollbar-thumb:hover': { backgroundColor: theme.palette.text.disabled },
                        scrollbarWidth: 'thin',
                        scrollbarColor: `${theme.palette.divider} ${theme.palette.background.paper}`
                      }}>
                        {/* OLD INVOICE MATERIALS TABLE (no cell borders) - kept for backup */}
                        {/* <Table> */}
                        {/* NEW INVOICE MATERIALS TABLE - borders on all cells */}
                        <Table sx={{ '& .MuiTableCell-root': { border: '1px solid', borderColor: theme.palette.divider } }}>
                          <TableHead>
                            <TableRow>
                              {/* OLD INVOICE MATERIALS HEADERS - kept for backup */}
                              {/* <TableCell align='center'>#</TableCell> */}
                              {/* <TableCell align='center'>PRODUCT</TableCell> */}
                              {/* <TableCell align='center'>Service</TableCell> */}
                              {/* {canViewCosts && <TableCell align='center'>UNIT PRICE</TableCell>} */}
                              {/* <TableCell align='center'>QTY</TableCell> */}
                              {/* <TableCell align='center'>Shipping Cost</TableCell> */}
                              {/* {canViewCosts && <TableCell align='center'>Service Cost</TableCell>} */}
                              {/* {canViewCosts && <TableCell align='center'>SUB TOTAL</TableCell>} */}
                              {/* NEW INVOICE MATERIALS HEADERS - aligned with Create/Edit Receive Order */}
                              <TableCell align='center'>ITEM</TableCell>
                              {/* OLD INVOICE MATERIALS DESCRIPTION HEADER (default width) - kept for backup */}
                              {/* <TableCell align='center'>DESCRIPTION</TableCell> */}
                              {/* PREVIOUS INVOICE MATERIALS DESCRIPTION HEADER (width 22% / minWidth 220) - kept for backup */}
                              {/* <TableCell align='center' sx={{ width: '22%', minWidth: 220 }}>DESCRIPTION</TableCell> */}
                              {/* NEW INVOICE MATERIALS DESCRIPTION HEADER - widened further per user request for more horizontal room */}
                              <TableCell align='center' sx={{ width: '28%', minWidth: 280 }}>DESCRIPTION</TableCell>
                              <TableCell align='center'>QTY ORDERED</TableCell>
                              {canViewCosts && <TableCell align='center'>UNIT COST</TableCell>}
                              <TableCell align='center'>QTY REC'D</TableCell>
                              <TableCell align='center'>DELIVERED</TableCell>
                              <TableCell align='center'>SERVICE NAME</TableCell>
                              {canViewCosts && <TableCell align='center'>SERVICE COST</TableCell>}
                              {canViewCosts && <TableCell align='center'>AMOUNT</TableCell>}
                            </TableRow>
                          </TableHead>
                          <TableBody>
                            {invoice?.filter(item => item.meterial == 1 && item.partial == 0).map((val,index) => {
                              const { id, name, description, unit_cost, actual_qty,actual_unit_qty,service_name, actual_total_cost,service_cost,shipping_cost,convertion_qty,convertion_unit,partial} = val    
                              const total_qty = actual_unit_qty * convertion_qty;
                              const unitName = convertion_unit? UNITS.find(item => item.id == convertion_unit)?.name:'Unit';
                              const quantity = convertion_unit==4 ?`${actual_unit_qty || 0} ${unitName}` : `${actual_unit_qty || 0}(${total_qty} ${unitName})`;
                                    // console.log("aaaaaaaaaaaaaaaaaaaaa",partial);            
                              return (
                                <TableRow key={`invoice-material-${id}`} sx={{
                                  borderBottom: (theme) => `solid 1px ${theme.palette.divider}`
                                }}>
                                  {/* OLD INVOICE MATERIALS ROW CELLS - kept for backup */}
                                  {/* <TableCell align='center'>{index+1}</TableCell> */}
                                  {/* <TableCell align='center'>{name}</TableCell> */}
                                  {/* <TableCell align='center'>{service_name || ''}</TableCell> */}
                                  {/* {canViewCosts && <TableCell align='center'>{unit_cost}</TableCell>} */}
                                  {/* <TableCell align='center'>{quantity}</TableCell> */}
                                  {/* <TableCell align='center'>{actual_qty}</TableCell> */}
                                  {/* <TableCell align='center'>{shipping_cost}</TableCell> */}
                                  {/* {canViewCosts && <TableCell align='center'>{service_cost}</TableCell>} */}
                                  {/* {canViewCosts && <TableCell align='center'>{actual_total_cost}</TableCell>} */}
                                  {/* NEW INVOICE MATERIALS ROW CELLS - aligned with Create/Edit Receive Order */}
                                  <TableCell align='center'>{name || '-'}</TableCell>
                                  <TableCell align='center'>{description || '-'}</TableCell>
                                  <TableCell align='center'>{quantity}</TableCell>
                                  {canViewCosts && <TableCell align='center'>{unit_cost}</TableCell>}
                                  <TableCell align='center'>{orderPreviewData[0]?.order_status === 0 ? '-' : quantity}</TableCell>
                                  <TableCell align='center'>-</TableCell>
                                  <TableCell align='center'>{service_name || '-'}</TableCell>
                                  {canViewCosts && <TableCell align='center'>{service_cost}</TableCell>}
                                  {canViewCosts && <TableCell align='center'>{actual_total_cost}</TableCell>}
                                </TableRow>
                              )
                            })}
                          </TableBody>
                        </Table>
                      </TableContainer>
                    </Scrollbar>
                  </Grid>
                )}

                {/* Catalogs Section */}
                {invoice?.filter(item => item.meterial == 0).length > 0 && (
                  <Grid item xs={12}>
                    <Typography variant="h6" sx={{ mt: 2, mb: 1, fontWeight: 'bold' }}>
                      Catalogs
                    </Typography>
                    <Scrollbar>
                      {/* OLD INVOICE CATALOGS TABLE CONTAINER (native scrollbar) - kept for backup */}
                      {/* <TableContainer sx={{ minWidth: '100%' }}> */}
                      {/* NEW INVOICE CATALOGS TABLE CONTAINER - theme-matched custom scrollbar */}
                      <TableContainer sx={{
                        minWidth: '100%',
                        '&::-webkit-scrollbar': { height: 8, width: 8 },
                        '&::-webkit-scrollbar-track': { backgroundColor: theme.palette.background.paper },
                        '&::-webkit-scrollbar-thumb': { backgroundColor: theme.palette.divider, borderRadius: 4 },
                        '&::-webkit-scrollbar-thumb:hover': { backgroundColor: theme.palette.text.disabled },
                        scrollbarWidth: 'thin',
                        scrollbarColor: `${theme.palette.divider} ${theme.palette.background.paper}`
                      }}>
                        {/* OLD INVOICE CATALOGS TABLE (no cell borders) - kept for backup */}
                        {/* <Table> */}
                        {/* NEW INVOICE CATALOGS TABLE - borders on all cells */}
                        <Table sx={{ '& .MuiTableCell-root': { border: '1px solid', borderColor: theme.palette.divider } }}>
                          <TableHead>
                            <TableRow>
                              {/* OLD INVOICE CATALOGS HEADERS - kept for backup */}
                              {/* <TableCell align='center'>#</TableCell> */}
                              {/* <TableCell align='center'>PRODUCT</TableCell> */}
                              {/* <TableCell align='center'>Service</TableCell> */}
                              {/* {canViewCosts && <TableCell align='center'>UNIT PRICE</TableCell>} */}
                              {/* <TableCell align='center'>QTY</TableCell> */}
                              {/* <TableCell align='center'>Shipping Cost</TableCell> */}
                              {/* {canViewCosts && <TableCell align='center'>Service Cost</TableCell>} */}
                              {/* {canViewCosts && <TableCell align='center'>SUB TOTAL</TableCell>} */}
                              {/* NEW INVOICE CATALOGS HEADERS - aligned with Create/Edit Receive Order */}
                              <TableCell align='center'>ITEM</TableCell>
                              {/* OLD INVOICE CATALOGS DESCRIPTION HEADER (default width) - kept for backup */}
                              {/* <TableCell align='center'>DESCRIPTION</TableCell> */}
                              {/* PREVIOUS INVOICE CATALOGS DESCRIPTION HEADER (width 22% / minWidth 220) - kept for backup */}
                              {/* <TableCell align='center' sx={{ width: '22%', minWidth: 220 }}>DESCRIPTION</TableCell> */}
                              {/* NEW INVOICE CATALOGS DESCRIPTION HEADER - widened further per user request for more horizontal room */}
                              <TableCell align='center' sx={{ width: '28%', minWidth: 280 }}>DESCRIPTION</TableCell>
                              <TableCell align='center'>QTY ORDERED</TableCell>
                              {canViewCosts && <TableCell align='center'>UNIT COST</TableCell>}
                              <TableCell align='center'>QTY REC'D</TableCell>
                              <TableCell align='center'>DELIVERED</TableCell>
                              <TableCell align='center'>SERVICE NAME</TableCell>
                              {canViewCosts && <TableCell align='center'>SERVICE COST</TableCell>}
                              {canViewCosts && <TableCell align='center'>AMOUNT</TableCell>}
                            </TableRow>
                          </TableHead>
                          <TableBody>
                            {invoice?.filter(item => item.meterial == 0).map((val,index) => {
                              const { id, name, description, unit_cost, actual_qty,service_name, actual_total_cost,service_cost,shipping_cost} = val              
                              return (
                                <TableRow key={`invoice-catalog-${id}`} sx={{
                                  borderBottom: (theme) => `solid 1px ${theme.palette.divider}`
                                }}>
                                  {/* OLD INVOICE CATALOGS ROW CELLS - kept for backup */}
                                  {/* <TableCell align='center'>{index+1}</TableCell> */}
                                  {/* <TableCell align='center'>{name}</TableCell> */}
                                  {/* <TableCell align='center'>{service_name || ''}</TableCell> */}
                                  {/* {canViewCosts && <TableCell align='center'>{unit_cost}</TableCell>} */}
                                  {/* <TableCell align='center'>{actual_qty}</TableCell> */}
                                  {/* <TableCell align='center'>{shipping_cost}</TableCell> */}
                                  {/* {canViewCosts && <TableCell align='center'>{service_cost}</TableCell>} */}
                                  {/* {canViewCosts && <TableCell align='center'>{actual_total_cost}</TableCell>} */}
                                  {/* NEW INVOICE CATALOGS ROW CELLS - aligned with Create/Edit Receive Order */}
                                  <TableCell align='center'>{name || '-'}</TableCell>
                                  <TableCell align='center'>{description || '-'}</TableCell>
                                  <TableCell align='center'>{actual_qty}</TableCell>
                                  {canViewCosts && <TableCell align='center'>{unit_cost}</TableCell>}
                                  <TableCell align='center'>{orderPreviewData[0]?.order_status === 0 ? '-' : actual_qty}</TableCell>
                                  <TableCell align='center'>-</TableCell>
                                  <TableCell align='center'>{service_name || '-'}</TableCell>
                                  {canViewCosts && <TableCell align='center'>{service_cost}</TableCell>}
                                  {canViewCosts && <TableCell align='center'>{actual_total_cost}</TableCell>}
                                </TableRow>
                              )
                            })}
                          </TableBody>
                        </Table>
                      </TableContainer>
                    </Scrollbar>
                  </Grid>
                )}

                {/* Services Section */}
                {orderServices && orderServices.length > 0 && (
                  <Grid item xs={12}>
                    <Typography variant="h6" sx={{ mt: 2, mb: 1, fontWeight: 'bold' }}>
                      Services
                    </Typography>
                    <Scrollbar>
                      {/* OLD INVOICE SERVICES TABLE CONTAINER (native scrollbar) - kept for backup */}
                      {/* <TableContainer sx={{ minWidth: '100%' }}> */}
                      {/* NEW INVOICE SERVICES TABLE CONTAINER - theme-matched custom scrollbar */}
                      <TableContainer sx={{
                        minWidth: '100%',
                        '&::-webkit-scrollbar': { height: 8, width: 8 },
                        '&::-webkit-scrollbar-track': { backgroundColor: theme.palette.background.paper },
                        '&::-webkit-scrollbar-thumb': { backgroundColor: theme.palette.divider, borderRadius: 4 },
                        '&::-webkit-scrollbar-thumb:hover': { backgroundColor: theme.palette.text.disabled },
                        scrollbarWidth: 'thin',
                        scrollbarColor: `${theme.palette.divider} ${theme.palette.background.paper}`
                      }}>
                        {/* OLD INVOICE SERVICES TABLE (no cell borders) - kept for backup */}
                        {/* <Table> */}
                        {/* NEW INVOICE SERVICES TABLE - borders on all cells */}
                        <Table sx={{ '& .MuiTableCell-root': { border: '1px solid', borderColor: theme.palette.divider } }}>
                          <TableHead>
                            <TableRow>
                              {/* OLD INVOICE SERVICES HEADERS - kept for backup */}
                              {/* <TableCell align='center'>#</TableCell> */}
                              {/* <TableCell align='center'>SERVICE</TableCell> */}
                              {/* {canViewCosts && <TableCell align='center'>PRICE</TableCell>} */}
                              {/* NEW INVOICE SERVICES HEADERS - aligned with Create/Edit Receive Order */}
                              <TableCell align='center'>#</TableCell>
                              <TableCell align='center'>SERVICES</TableCell>
                              {canViewCosts && <TableCell align='center'>TOTAL COST</TableCell>}
                            </TableRow>
                          </TableHead>
                          <TableBody>
                            {orderServices.map((val,index) => {
                              const serviceName = val.name || val.description || '';
                              const servicePrice = parseFloat(val.price) || 0;
                              return (
                                <TableRow key={`invoice-service-${val.id || index}`} sx={{
                                  borderBottom: (theme) => `solid 1px ${theme.palette.divider}`
                                }}>
                                  <TableCell align='center'>{index+1}</TableCell>
                                  <TableCell align='center'>{serviceName}</TableCell>
                                  {canViewCosts && <TableCell align='center'>${servicePrice.toFixed(2)}</TableCell>}
                                </TableRow>
                              )
                            })}
                          </TableBody>
                        </Table>
                      </TableContainer>
                    </Scrollbar>
                  </Grid>
                )}

                {/* Summary Table */}
                {/* OLD SUMMARY TABLE (Subtotal / Tax / Grand Total stack aligned right) - kept for backup */}
                {/* <Grid item xs={12}>
                  {canViewCosts && <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 2 }}>
                    <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end', minWidth: '200px' }}>
                      <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', width: '100%', mb: 1 }}>
                        <Typography variant="subtitle1">Subtotal</Typography>
                        <Typography variant="subtitle1" sx={{ ml: 4 }}>{fUSPrice(orderPreviewData[0]?.sub_total)}</Typography>
                      </Box>
                      <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', width: '100%', mb: 1 }}>
                        <Typography variant="subtitle1">Tax</Typography>
                        <Typography variant="subtitle1" sx={{ ml: 4 }}>{orderPreviewData[0]?.tax}</Typography>
                      </Box>
                      <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', width: '100%' }}>
                        <Typography variant="subtitle1" sx={{ fontWeight: 'bold' }}>Grand Total</Typography>
                        <Typography variant="subtitle1" sx={{ ml: 4, fontWeight: 'bold' }}>{fUSPrice(orderPreviewData[0]?.grand_total)}</Typography>
                      </Box>
                    </Box>
                  </Box>}
                </Grid> */}

                {/* PREVIOUS SUMMARY TABLE (font sizes 24px/18px/default + padding 12px - too large) - kept for backup */}
                {/* {canViewCosts && (
                  <Grid item xs={12}>
                    <TableContainer sx={{ mt: -2 }}>
                      <Table size="small" sx={{
                        tableLayout: 'fixed',
                        '& .MuiTableCell-root': {
                          border: '1px solid',
                          borderColor: theme.palette.divider,
                          padding: '12px'
                        }
                      }}>
                        <TableBody>
                          <TableRow>
                            <TableCell sx={{ verticalAlign: 'top', whiteSpace: 'pre-line', width: '66%', height: 140 }}>
                              <Typography component="span" sx={{ fontWeight: 'bold', textTransform: 'uppercase' }}>Vendor Notes / Special Instructions:</Typography>
                              <br />
                              {Array.isArray(orderPreviewData[0]?.notes) && orderPreviewData[0]?.notes?.length
                                ? orderPreviewData[0]?.notes?.join('\n')
                                : (typeof orderPreviewData[0]?.notes === 'string' ? orderPreviewData[0]?.notes : '')}
                            </TableCell>
                            <TableCell sx={{ width: '34%', textAlign: 'center', verticalAlign: 'middle' }}>
                              <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 1 }}>
                                <Typography sx={{ fontSize: '24px', fontWeight: 'bold', textTransform: 'uppercase' }}>Total</Typography>
                                <Typography sx={{ fontSize: '18px', fontWeight: 'bold' }}>${fUSPrice(orderPreviewData[0]?.grand_total)}</Typography>
                              </Box>
                            </TableCell>
                          </TableRow>
                          <TableRow>
                            <TableCell colSpan={2} sx={{ textAlign: 'left' }}>
                              <Typography component="span" sx={{ fontWeight: 'bold', textTransform: 'uppercase' }}>Purchased by:</Typography> {orderPreviewData[0]?.authorized_by || ''}
                            </TableCell>
                          </TableRow>
                        </TableBody>
                      </Table>
                    </TableContainer>
                  </Grid>
                )} */}

                {/* NEW SUMMARY TABLE - mirrors PurchaseOrderInvoicePage.js bottom section (VENDOR NOTES / SPECIAL INSTRUCTIONS + TOTAL + PURCHASED BY) using MUI Table; font sizes reduced + cell padding tightened per user feedback; visually connected to the items table above via mt: -2 to cancel the Grid container spacing */}
                {canViewCosts && (
                  <Grid item xs={12}>
                    <TableContainer sx={{ mt: -2 }}>
                      <Table size="small" sx={{
                        tableLayout: 'fixed',
                        '& .MuiTableCell-root': {
                          border: '1px solid',
                          borderColor: theme.palette.divider,
                          padding: '8px 10px',
                          fontSize: '13px'
                        }
                      }}>
                        <TableBody>
                          <TableRow>
                            {/* PREVIOUS SUMMARY NOTES CELL (fixed height 120) - kept for backup */}
                            {/* <TableCell sx={{ verticalAlign: 'top', whiteSpace: 'pre-line', width: '66%', height: 120 }}> */}
                            {/* NEW SUMMARY NOTES CELL - no fixed height, grows only when content needs it */}
                            <TableCell sx={{ verticalAlign: 'top', whiteSpace: 'pre-line', width: '66%' }}>
                              <Typography component="span" sx={{ fontSize: '13px', fontWeight: 'bold', textTransform: 'uppercase' }}>Vendor Notes / Special Instructions:</Typography>
                              <br />
                              {/* PREVIOUS SUMMARY NOTES VALUE (plain inherited text color) - kept for backup */}
                              {/* {Array.isArray(orderPreviewData[0]?.notes) && orderPreviewData[0]?.notes?.length
                                ? orderPreviewData[0]?.notes?.join('\n')
                                : (typeof orderPreviewData[0]?.notes === 'string' ? orderPreviewData[0]?.notes : '')} */}
                              {/* PREVIOUS SUMMARY NOTES VALUE TYPOGRAPHY (no explicit fontSize -> picked up the default body1 ~16px and looked oversized next to the 13px label) - kept for backup */}
                              {/* <Typography component="span" sx={{ color: 'error.main', whiteSpace: 'pre-line' }}> */}
                              {/* NEW SUMMARY NOTES VALUE - rendered in error.main (red) at fontSize 13px so it matches the label / surrounding cell text size */}
                              <Typography component="span" sx={{ color: 'error.main', whiteSpace: 'pre-line', fontSize: '13px' }}>
                                {Array.isArray(orderPreviewData[0]?.notes) && orderPreviewData[0]?.notes?.length
                                  ? orderPreviewData[0]?.notes?.join('\n')
                                  : (typeof orderPreviewData[0]?.notes === 'string' ? orderPreviewData[0]?.notes : '')}
                              </Typography>
                            </TableCell>
                            <TableCell sx={{ width: '34%', textAlign: 'center', verticalAlign: 'middle' }}>
                              <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 1 }}>
                                <Typography sx={{ fontSize: '16px', fontWeight: 'bold', textTransform: 'uppercase' }}>Total</Typography>
                                <Typography sx={{ fontSize: '14px', fontWeight: 'bold' }}>${fUSPrice(orderPreviewData[0]?.grand_total)}</Typography>
                              </Box>
                            </TableCell>
                          </TableRow>
                          <TableRow>
                            <TableCell colSpan={2} sx={{ textAlign: 'left' }}>
                              <Typography component="span" sx={{ fontSize: '13px', fontWeight: 'bold', textTransform: 'uppercase' }}>Purchased by:</Typography> {orderPreviewData[0]?.authorized_by || ''}
                            </TableCell>
                          </TableRow>
                        </TableBody>
                      </Table>
                    </TableContainer>
                  </Grid>
                )}
                          
              </Grid>
            </>
          }
          </Modal>
        )}

         {openEmailModal && (
           <SendDesignsEmailModal
             open={openEmailModal}
             onClose={() => { setOpenEmailModal(false); setInlineEmailOrderId(null); }}
             selectedDesigns={[
               {
                 id: inlineEmailOrderId || orderId,
                 name: `PurchaseOrder - ${(inlineEmailOrderId ? inlineEmailData.orderPreviewData[0]?.order_name : orderPreviewData[0]?.order_name) || 'N/A'}.pdf`,
                 file_type: 'application/pdf',
                 extension: 'pdf',
                 url: null,
                 invoiceData: {
                   invoiceDate: inlineEmailOrderId
                     ? (inlineEmailData.orderPreviewData[0]?.received_date
                       ? moment(inlineEmailData.orderPreviewData[0].received_date * 1000).format('MM/DD/YYYY')
                       : inlineEmailData.orderPreviewData[0]?.timestamp
                       ? moment(inlineEmailData.orderPreviewData[0].timestamp * 1000).format('MM/DD/YYYY')
                       : moment().format('MM/DD/YYYY'))
                     : invoiceDate,
                   details: inlineEmailOrderId ? inlineEmailData.orderPreviewData[0] : orderPreviewData[0],
                   invoice: inlineEmailOrderId ? inlineEmailData.invoice : invoice,
                   orderServices: inlineEmailOrderId ? inlineEmailData.orderServices : orderServices,
                   subTotal: (inlineEmailOrderId ? inlineEmailData.orderPreviewData[0]?.sub_total : orderPreviewData[0]?.sub_total) || 0,
                   tax: (inlineEmailOrderId ? inlineEmailData.orderPreviewData[0]?.tax : orderPreviewData[0]?.tax) || 0,
                   grandTotal: (inlineEmailOrderId ? inlineEmailData.orderPreviewData[0]?.grand_total : orderPreviewData[0]?.grand_total) || 0,
                   orderType: (inlineEmailOrderId ? inlineEmailData.orderPreviewData[0]?.orderType : orderPreviewData[0]?.orderType) || 1,
                 },
               },
             ]}
             hasViewCostPermission={canViewCosts}
             purchaseOrderId={inlineEmailOrderId || orderId}
             userId={userId}
             userType={userType}
             pageType="purchase_order"
             onSuccess={() => {
              //  enqueueSnackbar('Purchase Order email sent successfully', { variant: 'success' });
               setOpenEmailModal(false);
               setInlineEmailOrderId(null);
             }}
           />
         )}

         {/* Hidden print component for inline table print buttons */}
         <div style={{ display: 'none' }}>
           <PurchaseOrderInvoicePage
             invoiceDate={inlineInvoiceDate}
             details={inlinePrintData.orderPreviewData[0]}
             invoice={inlinePrintData.invoice}
             orderServices={inlinePrintData.orderServices}
             data={data}
             ref={inlinePrintRef}
             hasViewCostPermission={canViewCosts}
           />
         </div>

        {paymentOpen && (
          <Modal
            open={paymentOpen}
            handleClose={() => {
              setPaymentOpen(false);
              setSelectedPaymentMode(null)
              setValidSelection(true)
            }}
            modalTitle={`Make Payment - ${orderPreviewData[0]?.order_name}`}
          >
            <Grid container sx={{ justifyContent: 'center' }} spacing={3}>
              <Grid item xs={12} md={10}>
                <Stack
                  sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'space-between',
                  }}
                  spacing={3}
                >
                  <Stack
                    direction={{ xs: 'column', md: 'column' }} 
                    display="flex"
                    justifyContent="space-between"
                    spacing={3}
                  >
                    <Stack direction={{ xs: 'column', md: 'column' }}>
                    {/* <Typography variant="body">
                    Order ID: <span style={{ color:theme.palette.primary.dark, fontWeight:'bold' }}>{orderPreviewData[0]?.order_id}</span>
                    </Typography> */}
                    <Typography variant="body">
                      Order Name: <span style={{ color:theme.palette.primary.dark, fontWeight:'bold' }}>{orderPreviewData[0]?.order_name}</span>
                    </Typography>

                    
                    <Typography variant="subtitle1">
                          Vendor : <span style={{ color:theme.palette.primary.dark, fontWeight:'bold' }}>{orderPreviewData[0]?.vendor_name?orderPreviewData[0]?.vendor_name : ""}</span>
                        </Typography>
                        <Typography variant="subtitle1">
                          Qb Id : <span style={{ color:theme.palette.primary.dark, fontWeight:'bold' }}>{orderPreviewData[0]?.doc_number? `#${orderPreviewData[0]?.doc_number}` : ""}</span>
                        </Typography>
                    </Stack>

                    {/* <Card> */}
                    <Scrollbar>
                      {/* OLD PAYMENT TABLE CONTAINER (native scrollbar) - kept for backup */}
                      {/* <TableContainer sx={{ maxWidth: '100%', border: '1px solid', borderColor: theme.palette.divider}}> */}
                      {/* NEW PAYMENT TABLE CONTAINER - theme-matched custom scrollbar */}
                      <TableContainer sx={{
                        maxWidth: '100%',
                        border: '1px solid',
                        borderColor: theme.palette.divider,
                        '&::-webkit-scrollbar': { height: 8, width: 8 },
                        '&::-webkit-scrollbar-track': { backgroundColor: theme.palette.background.paper },
                        '&::-webkit-scrollbar-thumb': { backgroundColor: theme.palette.divider, borderRadius: 4 },
                        '&::-webkit-scrollbar-thumb:hover': { backgroundColor: theme.palette.text.disabled },
                        scrollbarWidth: 'thin',
                        scrollbarColor: `${theme.palette.divider} ${theme.palette.background.paper}`
                      }}>
                        <Table>
                          <TableBody>
                          <TableRow sx={{backgroundColor:theme.palette.divider}}>
                            {orderPreviewData[0]?.orderType === 3 ? (
                              <>
                                {/* OLD PAYMENT SERVICE HEADERS - kept for backup */}
                                {/* <TableCell align='center' sx={{ border: '1px solid',borderColor:theme.palette.divider }}>#</TableCell> */}
                                {/* <TableCell align='center' sx={{ border: '1px solid',borderColor:theme.palette.divider }}>Service Name</TableCell> */}
                                {/* <TableCell align='center' sx={{ border: '1px solid',borderColor:theme.palette.divider }}>Price</TableCell> */}
                                {/* NEW PAYMENT SERVICE HEADERS - aligned with Create/Edit Receive Order */}
                                <TableCell align='center' sx={{ border: '1px solid',borderColor:theme.palette.divider }}>#</TableCell>
                                <TableCell align='center' sx={{ border: '1px solid',borderColor:theme.palette.divider }}>SERVICES</TableCell>
                                <TableCell align='center' sx={{ border: '1px solid',borderColor:theme.palette.divider }}>TOTAL COST</TableCell>
                              </>
                            ) : (
                              <>
                                {/* OLD PAYMENT MATERIAL/CATALOG HEADERS - kept for backup */}
                                {/* <TableCell align='center' sx={{ border: '1px solid',borderColor:theme.palette.divider }}>#</TableCell> */}
                                {/* <TableCell align='center' sx={{ border: '1px solid',borderColor:theme.palette.divider }}>Product Name</TableCell> */}
                                {/* <TableCell align='center' sx={{ border: '1px solid',borderColor:theme.palette.divider }}>Service Name</TableCell> */}
                                {/* <TableCell align='center' sx={{ border: '1px solid',borderColor:theme.palette.divider }}>Unit Cost</TableCell> */}
                                {/* <TableCell align='center' sx={{ border: '1px solid',borderColor:theme.palette.divider }}>Quantity</TableCell> */}
                                {/* <TableCell align='center' sx={{ border: '1px solid', borderColor: theme.palette.divider }}>Service Cost</TableCell> */}
                                {/* <TableCell align='center' sx={{ border: '1px solid',borderColor:theme.palette.divider }}>Total</TableCell> */}
                                {/* NEW PAYMENT MATERIAL/CATALOG HEADERS - aligned with Create/Edit Receive Order */}
                                <TableCell align='center' sx={{ border: '1px solid',borderColor:theme.palette.divider }}>ITEM</TableCell>
                                {/* OLD PAYMENT MATERIAL/CATALOG DESCRIPTION HEADER (default width) - kept for backup */}
                                {/* <TableCell align='center' sx={{ border: '1px solid',borderColor:theme.palette.divider }}>DESCRIPTION</TableCell> */}
                                {/* PREVIOUS PAYMENT MATERIAL/CATALOG DESCRIPTION HEADER (width 22% / minWidth 220) - kept for backup */}
                                {/* <TableCell align='center' sx={{ border: '1px solid',borderColor:theme.palette.divider, width: '22%', minWidth: 220 }}>DESCRIPTION</TableCell> */}
                                {/* NEW PAYMENT MATERIAL/CATALOG DESCRIPTION HEADER - widened further per user request for more horizontal room */}
                                <TableCell align='center' sx={{ border: '1px solid',borderColor:theme.palette.divider, width: '28%', minWidth: 280 }}>DESCRIPTION</TableCell>
                                <TableCell align='center' sx={{ border: '1px solid',borderColor:theme.palette.divider }}>QTY ORDERED</TableCell>
                                <TableCell align='center' sx={{ border: '1px solid',borderColor:theme.palette.divider }}>UNIT COST</TableCell>
                                <TableCell align='center' sx={{ border: '1px solid',borderColor:theme.palette.divider }}>QTY REC'D</TableCell>
                                <TableCell align='center' sx={{ border: '1px solid',borderColor:theme.palette.divider }}>DELIVERED</TableCell>
                                <TableCell align='center' sx={{ border: '1px solid',borderColor:theme.palette.divider }}>SERVICE NAME</TableCell>
                                <TableCell align='center' sx={{ border: '1px solid', borderColor: theme.palette.divider }}>SERVICE COST</TableCell>
                                <TableCell align='center' sx={{ border: '1px solid',borderColor:theme.palette.divider }}>AMOUNT</TableCell>
                              </>
                            )}
                          </TableRow>
                          {loading ? (
                            <CircularProgress color="primary" variant="indeterminate" />
                          ) : (
                            <>
                            {orderPreviewData[0]?.orderType === 3 ? (
                              // Service-only orders
                              orderServices && orderServices.map((row,index) => {
                                const serviceName = row.name || row.description || '';
                                const servicePrice = parseFloat(row.price) || 0;
                                return (
                                  <TableRow
                                    hover
                                    key={`payment-service-${row.id || index}`}
                                    tabIndex={-1}
                                  >
                                    <TableCell align='center' sx={{ border: '0.5px solid',borderColor:theme.palette.divider }}> {index+1} </TableCell>
                                    <TableCell align="center" sx={{ border: '0.5px solid',borderColor:theme.palette.divider }}> {serviceName} </TableCell>
                                    <TableCell align="center" sx={{ border: '0.5px solid',borderColor:theme.palette.divider }}> ${servicePrice.toFixed(2)} </TableCell>
                                  </TableRow>
                                );
                              })
                            ) : (
                              // Materials/Catalogs orders
                              <>
                                {orderPreviewData?.filter(row => row.product_name).map((row,index) => {
                                  let { order_name,order_id, vendor_name, product_name,service_name, unit_cost, actual_qty, actual_unit_qty, actual_total_cost, service_cost, convertion_qty, convertion_unit } = row;
                                  const total_qty = actual_unit_qty * convertion_qty;
                                  const unitName = convertion_unit? UNITS.find(item => item.id == convertion_unit)?.name:'Unit';
                                  const quantity = convertion_unit==4 ?`${actual_unit_qty || 0} ${unitName}` : `${actual_unit_qty || 0}(${total_qty} ${unitName})`;
                                  const orderedQuantity = row.meterial == 1 ? quantity : (actual_qty || 0);
                                  const productDescription = invoice?.find(p => p?.material_inventory_id === row?.id)?.description || '-';
                                  return (
                                    <TableRow
                                      hover
                                      key={`payment-material-${index}`}
                                      tabIndex={-1}
                                    >
                                      {/* OLD PAYMENT MATERIAL/CATALOG ROW CELLS - kept for backup */}
                                      {/* <TableCell align='center' sx={{ border: '0.5px solid',borderColor:theme.palette.divider }}> {index+1} </TableCell> */}
                                      {/* <TableCell align="center" sx={{ border: '0.5px solid',borderColor:theme.palette.divider }}> {product_name} </TableCell> */}
                                      {/* <TableCell align="center" sx={{ border: '0.5px solid',borderColor:theme.palette.divider }}> {service_name || ''} </TableCell> */}
                                      {/* <TableCell align="center" sx={{ border: '0.5px solid',borderColor:theme.palette.divider }}> ${unit_cost || 0} </TableCell> */}
                                      {/* <TableCell align="center" sx={{ border: '0.5px solid',borderColor:theme.palette.divider }}> {actual_qty || 0} </TableCell> */}
                                      {/* <TableCell align="center" sx={{ border: '0.5px solid',borderColor:theme.palette.divider }}> ${service_cost || 0} </TableCell> */}
                                      {/* <TableCell align="center" sx={{ border: '0.5px solid',borderColor:theme.palette.divider }}> ${actual_total_cost || 0} </TableCell> */}
                                      {/* NEW PAYMENT MATERIAL/CATALOG ROW CELLS - aligned with Create/Edit Receive Order */}
                                      <TableCell align="center" sx={{ border: '0.5px solid',borderColor:theme.palette.divider }}> {product_name || '-'} </TableCell>
                                      <TableCell align="center" sx={{ border: '0.5px solid',borderColor:theme.palette.divider }}> {productDescription} </TableCell>
                                      <TableCell align="center" sx={{ border: '0.5px solid',borderColor:theme.palette.divider }}> {orderedQuantity} </TableCell>
                                      <TableCell align="center" sx={{ border: '0.5px solid',borderColor:theme.palette.divider }}> ${unit_cost || 0} </TableCell>
                                      <TableCell align="center" sx={{ border: '0.5px solid',borderColor:theme.palette.divider }}> {orderedQuantity} </TableCell>
                                      <TableCell align="center" sx={{ border: '0.5px solid',borderColor:theme.palette.divider }}> - </TableCell>
                                      <TableCell align="center" sx={{ border: '0.5px solid',borderColor:theme.palette.divider }}> {service_name || ''} </TableCell>
                                      <TableCell align="center" sx={{ border: '0.5px solid',borderColor:theme.palette.divider }}> ${service_cost || 0} </TableCell>
                                      <TableCell align="center" sx={{ border: '0.5px solid',borderColor:theme.palette.divider }}> ${actual_total_cost || 0} </TableCell>
                                    </TableRow>
                                  );
                                })}
                                {/* Services rows for mixed orders */}
                                {orderServices && orderServices.map((row,index) => {
                                  const serviceName = row.name || row.description || '';
                                  const servicePrice = parseFloat(row.price) || 0;
                                  const materialsCount = orderPreviewData?.filter(row => row.product_name).length || 0;
                                  const rowIndex = materialsCount + index + 1;
                                  return (
                                    <TableRow
                                      hover
                                      key={`payment-service-${row.id || index}`}
                                      tabIndex={-1}
                                    >
                                      {/* OLD PAYMENT MIXED SERVICE ROW CELLS - kept for backup */}
                                      {/* <TableCell align='center' sx={{ border: '0.5px solid',borderColor:theme.palette.divider }}> {rowIndex} </TableCell> */}
                                      {/* <TableCell align="center" sx={{ border: '0.5px solid',borderColor:theme.palette.divider }}> {serviceName} </TableCell> */}
                                      {/* <TableCell align="center" sx={{ border: '0.5px solid',borderColor:theme.palette.divider }}> - </TableCell> */}
                                      {/* <TableCell align="center" sx={{ border: '0.5px solid',borderColor:theme.palette.divider }}> - </TableCell> */}
                                      {/* <TableCell align="center" sx={{ border: '0.5px solid',borderColor:theme.palette.divider }}> - </TableCell> */}
                                      {/* <TableCell align="center" sx={{ border: '0.5px solid',borderColor:theme.palette.divider }}> - </TableCell> */}
                                      {/* <TableCell align="center" sx={{ border: '0.5px solid',borderColor:theme.palette.divider }}> ${servicePrice.toFixed(2)} </TableCell> */}
                                      {/* NEW PAYMENT MIXED SERVICE ROW CELLS - fits material/catalog columns */}
                                      <TableCell align='center' sx={{ border: '0.5px solid',borderColor:theme.palette.divider }}> - </TableCell>
                                      <TableCell align="center" sx={{ border: '0.5px solid',borderColor:theme.palette.divider }}> - </TableCell>
                                      <TableCell align="center" sx={{ border: '0.5px solid',borderColor:theme.palette.divider }}> - </TableCell>
                                      <TableCell align="center" sx={{ border: '0.5px solid',borderColor:theme.palette.divider }}> - </TableCell>
                                      <TableCell align="center" sx={{ border: '0.5px solid',borderColor:theme.palette.divider }}> - </TableCell>
                                      <TableCell align="center" sx={{ border: '0.5px solid',borderColor:theme.palette.divider }}> - </TableCell>
                                      <TableCell align="center" sx={{ border: '0.5px solid',borderColor:theme.palette.divider }}> {serviceName} </TableCell>
                                      <TableCell align="center" sx={{ border: '0.5px solid',borderColor:theme.palette.divider }}> - </TableCell>
                                      <TableCell align="center" sx={{ border: '0.5px solid',borderColor:theme.palette.divider }}> ${servicePrice.toFixed(2)} </TableCell>
                                    </TableRow>
                                  );
                                })}
                              </>
                            )}
                            </>
                          )}
                          </TableBody>
                        </Table>
                      </TableContainer>
                    </Scrollbar>
                    <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 2 }}>
                      <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end', minWidth: '200px' }}>
                        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', width: '100%', mb: 1 }}>
                          <Typography variant="subtitle2">Sub Total</Typography>
                          <Typography variant="subtitle2" sx={{ ml: 4, color: theme.palette.primary.dark }}>${orderPreviewData[0]?.sub_total}</Typography>
                        </Box>
                        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', width: '100%', mb: 1 }}>
                          <Typography variant="subtitle2">Tax</Typography>
                          <Typography variant="subtitle2" sx={{ ml: 4, color: theme.palette.primary.dark }}>{orderPreviewData[0]?.tax}</Typography>
                        </Box>
                        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', width: '100%' }}>
                          <Typography variant="subtitle2" sx={{ fontWeight: 'bold' }}>Grand Total</Typography>
                          <Typography variant="subtitle2" sx={{ ml: 4, fontWeight: 'bold', color: theme.palette.primary.dark }}>${orderPreviewData[0]?.grand_total}</Typography>
                        </Box>
                      </Box>
                    </Box>
                    {/* </Card> */}
                    <Divider />
                    <LabelStyleHead>Payments</LabelStyleHead>
                    <Stack direction={{ xs: 'column', sm: 'column' }} spacing={{ xs: 3, sm: 2 }}>
                    <Typography sx={{color:theme.palette.primary.main}}>Amount : ${orderPreviewData[0]?.grand_total}</Typography>
                      {/* <Stack direction={{ xs: 'column', sm: 'row' }} spacing={{ xs: 3, sm: 2 }}>
                      <TableContainer component={Paper}>
                        <Table>
                           <TableHead>
                             <TableRow>
                               <TableCell>Sl.no.</TableCell> 
                                 <TableCell>Payment Mode</TableCell> 
                                 <TableCell>Amount : ${orderPreviewData[0]?.grand_total}</TableCell>
                               <TableCell>Action</TableCell>
                             </TableRow>
                           </TableHead>
                          <TableBody>
                            {rows.map((row, index) => (
                              <TableRow>
                                <TableCell width='15px'>1</TableCell>
                                <TableCell>
                                  <TextField
                                    value={row.paymentMode}
                                    onChange={(event) => handlePaymentModeChange(event, index)}
                                    variant="outlined"
                                    fullWidth
                                    autoComplete="off"
                                  />
                                  <Autocomplete
                                    select
                                    fullWidth
                                    id={`paymentMode`}
                                    options={paymentTypes}
                                    // value={selectedPaymentMode}
                                    value = {paymentTypes?.find((option) => option.id === selectedPaymentMode) || null}
                                    onChange={(event, newValue) => {setSelectedPaymentMode(newValue ? newValue?.id : null); setValidSelection(true);}}
                                    getOptionLabel={(option) => option.name}
                                    renderInput={(params) => (
                                      <TextField
                                        {...params}
                                        label="Select Payment Mode"
                                        fullWidth
                                        error={!validSelection}
                                        helperText={!validSelection && "Please select a payment mode"}
                                      />
                                    )}
                                  />
                                </TableCell>
                                <TableCell>
                                  <TextField
                                    type="number"
                                    value={row.amount}
                                    onChange={(event) => handleAmountChange(event, index)}
                                    variant="outlined"
                                    fullWidth
                                    InputProps={{ inputProps: { min: 0 } }}
                                  />
                                </TableCell>
                                <TableCell>
                                  {(index > 0) && <IconButton onClick={() => handleDeleteRow(index)}>
                                    <Delete />
                                  </IconButton>}
                                </TableCell>
                              </TableRow>
                            ))}
                          </TableBody>
                        </Table>
                      </TableContainer> */}
                      <Autocomplete
                        select
                        fullWidth
                        id={`paymentMode`}
                        options={paymentTypes}
                        // value={selectedPaymentMode}
                        value = {paymentTypes?.find((option) => option.id === selectedPaymentMode) || null}
                        onChange={(event, newValue) => {setSelectedPaymentMode(newValue ? newValue?.id : null); setValidSelection(true);}}
                        getOptionLabel={(option) => option.name}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            label="Select Payment Mode"
                            fullWidth
                            error={!validSelection}
                            helperText={!validSelection && "Please select a payment mode"}
                          />
                        )}
                      />
                    </Stack>
                    {/* <Box sx={{ mt: 3, display: 'flex', justifyContent: 'space-between', gap:2 }}>
                      <Button variant="contained" color="primary" onClick={handleAddRow}>Add Payment</Button>
                      <Typography variant='body'>Balance Due : {orderPreviewData[0]?.grand_total-totalAmount}</Typography>
                    </Box> */}
                      
                    <Box sx={{ mt: 3, display: 'flex', justifyContent: 'flex-end', gap:2 }}>
                      <Button variant='contained' type='submit' disabled={loading2} onClick={handleReceivePayment}>{loading2 ? <CircularProgress size={24} color="inherit" /> : 'Pay'}</Button>
                      <Button variant='outlined' disabled={loading2} onClick={()=>{setPaymentOpen(false)}}>Cancel</Button>
                    </Box>
                  </Stack> 

                </Stack>
              </Grid>
            </Grid>
          </Modal>
        )}

      </Container>
  );
}

const PrintFunction = forwardRef(({ invoiceDate, details, invoice, orderServices, data }, ref) => {
  const theme = useTheme();

  return (
    <Stack ref={ref}>
      <style>
        {`
          @media print {
            img[alt="logo"] {
              display: block !important;
              visibility: visible !important;
              opacity: 1 !important;
            }
          }
        `}
      </style>
      <Grid container spacing={3}>
      <Grid item xs={12} sm={6} sx={{ mb: 5, display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }}>
          <Box 
            component="img" 
            alt="logo" 
            src={COMPANY_LOGO} 
            sx={{ 
              height: 98, 
              alignSelf: 'flex-start',
              '@media print': {
                display: 'block !important',
                visibility: 'visible !important',
                opacity: '1 !important'
              }
            }} 
          />
        </Grid>
        <Grid item xs={12} sm={6} sx={{ mb: 5, display: 'flex', flexDirection: 'column', alignItems: 'flex-end' }}>
          {/* <Typography variant="h1">Invoice from:</Typography> */}
          <Typography variant="h2">{COMPANY_NAME}</Typography>
          <Typography variant="h3">www.{COMPANY_NAME}.com</Typography>
          {/* <Typography variant="h3">
            1st Floor, Administrative block, Kinfra Integrated <br /> Industrial Park, Ottapalam, Palakkad, Kerala, India
          </Typography>
          <Typography variant="h3">Telephone: +91-9496351674</Typography> */}
        </Grid>
      </Grid>

      <Grid container spacing={2}>

        <Grid id="total1"  item xs={12} sm={6} >
        <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end' }}>        
        <Box id="order" style={{ display: 'flex', alignItems: 'center',justifyContent:'space-between'  }}>
          <Typography id="discount1" variant="h3" style={{ textAlign:'left'}}>Order date:</Typography>
          <Typography variant="h3">{invoiceDate}</Typography>
        </Box>
        <Box id="title" style={{ display: 'flex', alignItems: 'center',justifyContent:'space-between'  }}>
          <Typography id="discount1" variant="h3" style={{ textAlign:'left'}}>Order Name:</Typography>
          <Typography variant="h3">{details?.order_name}</Typography>
        </Box>
        {/* <Box id="orderID" style={{ display: 'flex', alignItems: 'center',justifyContent:'space-between'  }}>
          <Typography id="discount" variant="h3" style={{ textAlign:'left'}}>Order ID:</Typography>
          <Typography variant="h3">{details?.order_id}</Typography>
        </Box> */}
        <Box id="to" style={{ display: 'flex', alignItems: 'center',justifyContent:'space-between' }}>
          <Typography id="totalmain1" variant="h3" >Vendor Name:</Typography>
          <Typography variant="h3" style={{textAlign:'right'}}>{details?.vendor_name}</Typography>
        </Box>
        <Box style={{ display: 'flex', alignItems: 'center',justifyContent:'space-between' }}>
          <Typography id="totalmain1" variant="h3" >Phone:</Typography>
          <Typography variant="h3" style={{textAlign:'right'}}>{details?.vendor_phone}</Typography>          
        </Box>
        <Box style={{ display: 'flex', alignItems: 'center',justifyContent:'space-between' }}>
          <Typography id="totalmain1" variant="h3" >Qb Id:</Typography>
          <Typography variant="h3" style={{textAlign:'right'}}>{details?.doc_number?`#${details?.doc_number}` : ""}</Typography>
        </Box>
            
          </Box>
        </Grid>

        {/* Materials Section */}
        {invoice?.filter(item => item.meterial == 1).length > 0 && (
          <Grid item xs={12}>
            <Typography variant="h3" sx={{ mt: 2, mb: 1, fontWeight: 'bold' }}>
              Materials
            </Typography>
            <Scrollbar>
              <TableContainer sx={{ minWidth: 420 }}>
                <Table>
                  <TableHead>
                    <TableRow>
                      <TableCell align='center'>#</TableCell>
                      <TableCell align='center'>PRODUCT</TableCell>
                      <TableCell align='center'>Service</TableCell>
                      <TableCell align='center'>UNIT PRICE</TableCell>
                      <TableCell align='center'>QTY</TableCell>
                      {/* <TableCell align='center'>Shipping Cost</TableCell> */}
                      <TableCell align='center'>Service Cost</TableCell>
                      <TableCell align='center'>SUB TOTAL</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {invoice?.filter(item => item.meterial == 1).map((val,index) => {
                      const { id, name, unit_cost,service_name, actual_qty,actual_unit_qty, actual_total_cost,shipping_cost,service_cost} = val
                      return (
                        <TableRow key={`print-material-${id}`} sx={{
                          borderBottom: (theme) => `solid 1px ${theme.palette.divider}`,
                          '& .productName': {
                            fontWeight: 'bold',
                          },
                        }}>
                          <TableCell align='center' variant="h4">{index+1}</TableCell>
                          <TableCell align='center' variant="h4" className="productName">{name}</TableCell>
                          <TableCell align='center' variant="h4" className="productName">{service_name || ''}</TableCell>
                          <TableCell align='center' variant="h4">{unit_cost}</TableCell>
                          <TableCell align='center' variant="h4">{actual_unit_qty}</TableCell>
                          {/* <TableCell align='center' variant="h4">{actual_qty}</TableCell> */}
                          {/* <TableCell align='center' variant="h4">{shipping_cost}</TableCell> */}
                          <TableCell align='center' variant="h4">{service_cost}</TableCell>
                          <TableCell align='center' variant="h4">{actual_total_cost}</TableCell>
                        </TableRow>
                        )
                      }
                    )}
                  </TableBody>
                </Table>
              </TableContainer>
            </Scrollbar>
          </Grid>
        )}

        {/* Catalogs Section */}
        {invoice?.filter(item => item.meterial == 0).length > 0 && (
          <Grid item xs={12}>
            <Typography variant="h3" sx={{ mt: 2, mb: 1, fontWeight: 'bold' }}>
              Catalogs
            </Typography>
            <Scrollbar>
              <TableContainer sx={{ minWidth: 420 }}>
                <Table>
                  <TableHead>
                    <TableRow>
                      <TableCell align='center'>#</TableCell>
                      <TableCell align='center'>PRODUCT</TableCell>
                      <TableCell align='center'>Service</TableCell>
                      <TableCell align='center'>UNIT PRICE</TableCell>
                      <TableCell align='center'>QTY</TableCell>
                      {/* <TableCell align='center'>Shipping Cost</TableCell> */}
                      <TableCell align='center'>Service Cost</TableCell>
                      <TableCell align='center'>SUB TOTAL</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {invoice?.filter(item => item.meterial == 0).map((val,index) => {
                      const { id, name, unit_cost,service_name, actual_qty, actual_total_cost,shipping_cost,service_cost} = val
                      return (
                        <TableRow key={`print-catalog-${id}`} sx={{
                          borderBottom: (theme) => `solid 1px ${theme.palette.divider}`,
                          '& .productName': {
                            fontWeight: 'bold',
                          },
                        }}>
                          <TableCell align='center' variant="h4">{index+1}</TableCell>
                          <TableCell align='center' variant="h4" className="productName">{name}</TableCell>
                          <TableCell align='center' variant="h4" className="productName">{service_name || ''}</TableCell>
                          <TableCell align='center' variant="h4">{unit_cost}</TableCell>
                          <TableCell align='center' variant="h4">{actual_qty}</TableCell>
                          {/* <TableCell align='center' variant="h4">{shipping_cost}</TableCell> */}
                          <TableCell align='center' variant="h4">{service_cost}</TableCell>
                          <TableCell align='center' variant="h4">{actual_total_cost}</TableCell>
                        </TableRow>
                        )
                      }
                    )}
                  </TableBody>
                </Table>
              </TableContainer>
            </Scrollbar>
          </Grid>
        )}

        {/* Services Section */}
        {orderServices && orderServices.length > 0 && (
          <Grid item xs={12}>
            <Typography variant="h3" sx={{ mt: 2, mb: 1, fontWeight: 'bold' }}>
              Services
            </Typography>
            <Scrollbar>
              <TableContainer sx={{ minWidth: 420 }}>
                <Table>
                  <TableHead>
                    <TableRow>
                      <TableCell align='center'>#</TableCell>
                      <TableCell align='center'>SERVICE</TableCell>
                      <TableCell align='center'>PRICE</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {orderServices.map((val,index) => {
                      const serviceName = val.name || val.description || '';
                      const servicePrice = parseFloat(val.price) || 0;
                      return (
                        <TableRow key={`print-service-${val.id || index}`} sx={{
                          borderBottom: (theme) => `solid 1px ${theme.palette.divider}`,
                          '& .productName': {
                            fontWeight: 'bold',
                          },
                        }}>
                          <TableCell align='center' variant="h4">{index+1}</TableCell>
                          <TableCell align='center' variant="h4" className="productName">{serviceName}</TableCell>
                          <TableCell align='center' variant="h4">${servicePrice.toFixed(2)}</TableCell>
                        </TableRow>
                      )
                    })}
                  </TableBody>
                </Table>
              </TableContainer>
            </Scrollbar>
          </Grid>
        )}

        <Grid id="total"  item xs={12} sm={6} >
          <Box sx={{ mb: 2, display: 'flex', flexDirection: 'column', alignItems: 'flex-end' }}>
            <Box style={{ display: 'flex', alignItems: 'center',justifyContent:'space-between' }}>
              <Typography id="subtotal" variant="h3" >Sub Total</Typography>
              <Typography variant="h3" style={{textAlign:'right'}}>${details?.sub_total}</Typography>
            </Box>
            <Box style={{ display: 'flex', alignItems: 'center',justifyContent:'space-between'  }}>
              <Typography id="discount" variant="h3" style={{ textAlign:'left'}}>Tax</Typography>
              <Typography variant="h3">{details?.tax}</Typography>
            </Box>
            <Box style={{ display: 'flex', alignItems: 'center',justifyContent:'space-between' }}>
              <Typography id="totalmain" variant="h3" >Grand Total</Typography>
              <Typography variant="h3" style={{textAlign:'right'}}>${details?.grand_total}</Typography>
            </Box>
          </Box>
        </Grid>
                      
      </Grid>
    </Stack>
  )
})
